export default {
	en: {
		headers: {
			'main': 'Homepage',
			'advanced_search_results': 'Advanced search results',
			'card': 'Page',
			'full_results': 'Search results',
			'advanced_search': 'Advanced search',
			'record': 'Record',
			'files': {
				'person': 'File of people',
				'creative-work': 'File of list',
				'journal': 'File of periodicals',
				'event': 'File of events',
				'institution': 'File of institutions',
				'series': 'File of series',
			}
		},
		alerts: {
			'success': 'The user has been logged in',
			'error': 'A login error has occurred',
			'error_auth': 'Bad login or password',
			'logout_success': 'The user has been logged out',
		},
		titles: {
			'pbl': 'PBL',
			'main': 'Homepage',
			'results': 'Search results',
			'advanced-results': 'Advanced search results',
			'results_for': 'for',
			'headings': 'PBL domains and subjects headings',
			'headings-about': 'Characteristic of PBL domains and subjects headings',
			'headings-search': 'Characteristic of PBL domains and subjects headings',
			'records': 'Records',
			'records-about': 'Characteristic of PBL records',
			'files': 'Files',
			'files-about': 'Characteristic of PBL files',
			'files-person': 'File of people',
			'files-institution': 'File of institutions',
			'files-event': 'File of events',
			'files-creative-work': 'File of works',
			'files-series': 'File of series',
			'files-journal': 'File of periodicals',
			'item-book': 'Books',
			'item-journal-item': 'Material in periodical',
			'item-movie': 'Movie',
			'item-spectacle': 'Theater performance',
			'item-radio': 'Radio programs',
			'item-television': 'Television programs',
			'item-content': 'Material in book',
			'item-person': 'File of people',
			'item-institution': 'File of institutions',
			'item-event': 'File of events',
			'item-event-series': 'File of events',
			'item-series': 'File of series',
			'item-journal': 'File of periodicals',
			'item-journal-number': 'File of periodicals',
			'item-creative-work': 'File of works',
			'person': 'Files',
			'institution': 'Files',
			'event': 'Files',
			'series': 'Files',
			'journal': 'Files',
			'about': 'About PBL',
			'about-what-is': 'What is PBL?',
			'about-how-search': 'How to search and read results?',
			'about-what-in': 'What can you find in PBL?',
			'about-examples': 'Query examples',
			'about-how-create': 'How the PBL is made?',
			'about-source': 'PBL sources',
			'about-conditions': 'Data access terms and conditions',
			'about-team': 'Team',
			'about-contact': 'Contact',
			'about-privacy-policy': 'Privacy policy',
            'about-accessibility' : 'Accessibility statement',
			'news': 'News',
			'news-all': 'All news',
			'news-events': 'Events',
			'news-conferences': 'Conferences',
			'news-publications': 'Publications',
			'news-from-life': 'See how we work',
			'news-projects': 'Projects',
			'advanced-search': 'Advanced search',
			'collections': 'PBL collections characteristic',
		},
		breadcrumbs: {
			'home': 'Homepage',
			'records': 'Records',
			'cards': 'Files',
			'files': 'Files',
			'book': 'Books',
			'news': 'News',
			'content': 'Materials in books',
			'movie': 'Movies',
			'radio': 'Radio programs',
			'spectacle': 'Theater performances',
			'journal-item': 'Materials in periodicals',
			'television': 'Television programs',
			'headings': 'PBL domains and subjects headings',
			'headings_about': 'PBL domains and subjects headings description',
			'headings_results': 'Search in the name of the department',
			'about-pbl': 'About PBL',
			'journal-number': 'File of periodicals',
			'journal': 'File of periodicals',
			'series': 'File of series',
			'event': 'File of events',
			'person': 'File of people',
			'creative-work': 'File of works',
			'institution': 'File of institutions',
			'event-series': 'File of events',
			'all': 'All news',
			'events': 'Events',
			'research-work': 'Research',
			'publications': 'Publications',
			'from-life': 'From life of PBB',
			'projects': 'Projects',
			'collections': 'Collections',
			'collections-about': 'PBL collections characteristic',
			'movie-theatre-rtv': 'Theater, film, radio and television',
			'literature-theory': 'Literary theory',
			'polish-literature': 'Polish literature',
			'foreign-literature': 'Foreign literatures',
		},
		validation: {
			'required': 'Required',
			'no_fields': 'At least one query is required'
		},
		errors: {
			'error_404': 'Error 404: page not found.',
			'error_404_desc': '<li>Wrong URL - check if it is correct, </li><li>Page does not exist (it never has or was removed), </li><li>Page changed its name or URL.</li>',
			'error_500': 'Internal server error',
			'error_500_desc': 'This page cannot be displayed due to internal server error. </br> Refresh or try again in a few minutes. If the error persists please <a href="/about/contact">contact us</a>',
			'error_code': 'Error ',
			'error_causes': 'Possible causes: ',
			'sorry': 'Sorry for the incovenience',
			'what_now': 'What now?',
			'go_to_homepage': 'Go to homepage',
			'use_map': 'Use the map below',
			'error_info': 'Information: ',
		},
		header: {
			'contact': 'Contact'
		},
		footer: {
			'credits': 'Software',
			'pcss': 'provided by the Poznań Supercomputing and Networking Center',
			'visit': 'Visit us',
			'admin': 'Administration panel',
			'login': 'Log in',
			'fb': 'Facebook',
			'sitemap': 'Website Map'
		},
		about_pbl: {
			'what-in': 'What can you find in PBL?',
			'what-is': 'What is PBL?',
			'how-search': 'How to search and read results?',
			'examples': 'Query examples',
			'examples_desc': 'Przykładowe opisy kwerend w bazie PBL wykonanych z wykorzystaniem podstawowego okna wyszukiwania i faset, opcji wyszukiwania zaawansowanego lub przeglądania zawartości bazy przez widoki dziedzin i działów, kartoteki lub zapisy. W każdej kwerendzie wskazujemy jeden problem badawczy lub jedno zapytanie wyszukiwawcze i wyjaśniamy, w jaki sposób otrzymać satysfakcjonujące wyniki.',
			'how-create': 'How the PBL is made?',
			'source': 'PBL sources',
			'conditions': 'Data access terms and conditions',
			'team': 'Our team',
			'contact': 'Contact',
			'privacy-policy': 'Privacy policy',
			'query_results': 'See results for this query',
			'api-docs': 'API Docs',
            'accessibility' : 'Accessibility statement'
		},
		news: {
			'all': 'All news',
			'news': 'News',
			'events': 'Events',
			'conferences': 'Conferences',
			'publications': 'Publications',
			'from-life': 'From life of PBB',
			'projects': 'Projects',
			'search': 'Search news',
			'categories': 'Categories',
			'no_results_title': "We haven't found the results to match your request.",
			'no_results_suggestions': "Unfortunately, we haven't found anything on the site that matches the password you're looking for. Try searching with other keywords or phrases.",
			'no_results_all_news': 'Go to all news',
			'no_results_change_query': 'Change query',
		},
		news_desc: {
			'all': 'News related to the activities of the Current Bibliography Studio of the IBL PAN in Poznań and the development of the „Polish Literary Bibliography”.',
			'events': 'Information about events - workshops, open meetings, lectures - organized by the Current Bibliography Studio team, as well as about the participation of its members in popularization or educational projects.',
			'conferences': 'News on conferences related to the activities of the Current Bibliography Studio and related issues.',
			'publications': 'Information on publications concerning the „Polish Literary Bibliography” and the most interesting research results in the field of scientific information and library science.',
			'from-life': 'Information on the functioning of the Current Bibliography Studio - curiosities from the life of the Studio, staff changes, current job offers.',
			'projects': 'Information on research projects carried out by the Current Bibliography Studio.',
			'search': 'Search for News',
		},
		search: {
			'how': 'How to search and read results?',
			'info': 'Searched phrase',
			'about': 'Concerning',
			'count': 'Number of results',
			'area': 'Area',
			'advanced': 'Advanced search',
			'what': 'Enter searched word or phrase',
			'where': 'Where are you searching?',
			options: {
				'all': 'Entire PBL content',
				'records': 'Records',
				'person': 'People',
				'creative-work': 'Works',
				'journal': 'Periodicals',
				'event': 'Events',
				'institution': 'Institutions',
				'series': 'Series',
				'publishing-series': 'Publishing series',
				'event-series': 'Event series',
			},
			options_single: {
				'all': 'All PBL records',
				'records': 'Record',
				'person': 'Person',
				'creative-work': 'Work',
				'journal': 'Periodical',
				'event': 'Event',
				'institution': 'Institution',
				'series': 'Series',
				'publishing-series': 'Publishing series',
				'event-series': 'Event series',
			},
		},
		main_page: {
			'about': 'Data on <strong>literary</strong>, <strong>theatrical</strong>  and <strong>film culture</strong> for <strong>1989-2023</strong>',
			'browse_headings': 'Search subjects headings',
			'records_headings': 'Number of records in a subject',
			'literature-theory': 'Theory of literature',
			'polish-literature': 'Polish literature',
			'foreign-literature': 'Foreign literatures',
			'movie-theatre-rtv': 'Theater, film, radio, television',
			'news': 'News',
			'news_all': 'All news',
			'72': 'From life of PBB',
			'60': 'Events',
			'76': 'Conferences',
			'74': 'Publications',
			'79': 'Projekty',
			'68': 'Z życia PBB',
			'35': 'Wydarzenia',
			'66': 'Konferencje',
			'70': 'Publikacje',
			'81': 'Projects',
			'more_pbl': 'More about PBL',
			'possibilities_btn': 'PBL in the OPEN repository',
			'menu': 'Menu',
			'numbers': 'PBL <strong>in figures</strong>',
			'what_in': '<strong>What can you find</strong> in PBL?',
			'more_queries_examples': 'More examples of queries',
			'types': {
				'author': 'Authors',
				'creative-work': 'Works',
				'book': 'Books',
				'review': 'Reviews',
				'movie': 'Films',
				'event': 'Events',
				'spectacle': 'Theater performances',
				'rtv': 'Radio plays'
			}
		},
		advanced_search: {
			tabs: {
				'all': 'All PBL records',
				'records': 'Records',
				'person': 'People',
				'creative-work': 'Works',
				'journal': 'Periodicals',
				'event': 'Events',
				'institution': 'Institutions',
				'event-series': 'Event series',
				'publishing-series': 'Publishing series',
				'series': 'Series',
			},
			search_field_options: {
				'TITLE': 'Title',
				'KIND': 'Form and type',
				'TYPE': 'Publication type',
				'WORK': 'Work',
				'DATE': 'Publication date',
				'SERIES': 'Series',
				'PBLISHING_SERIES': 'Publishing series',
				'COLLECTION': 'Collection',
				'TEXT': 'Text',
				'PERSON': 'Person',
				'SEX': 'Sex',
				'DEATH_DATE': 'Date of death',
				'TEXT_IN_ANNOTATION': 'Text in annotation field',
				'ROLE': 'Role',
				'SEARCH_FORM': 'Series form',
				'PERSON_NAME': 'Person name',
				'HEADING': 'PBL domain and subject heading',
				'DATE_OF_BIRTH': 'Date of birth',
				'PLACE_OF_BIRTH': 'Place of birth',
				'DATE_OF_DEATH': 'Date of death',
				'PLACE_OF_DEATH': 'Place of death',
				'ORIGIN': 'Information provenance',
				'ANNOTATIONS': 'Annotations',
				'REMARKS': 'Remarks',
				'INNER_TAG': 'Inner tags',
				'LINKED_INSTITUTION': 'Linked institution',
				'LINKED_JOURNAL_SOURCE': 'Linked journal source',
				'AUTHORS': 'Authors',
				'SENDERS': 'Senders',
				'INTERLOCUTORS': 'Interlocutors',
				'ADRESSES': 'Addresses',
				'SOURCES': 'Sources',
				'EVENT_NAME': 'Name',
				'EVENT_TYPE': 'Type',
				'EDITION_NUMBER': 'Edition number',
				'FOR_PERIOD': 'For period',
				'EVENT_PLACE': 'Place',
				'BELONGING_TO_EVENT_SERIES': 'Belonging to event series',
				'EVENT_ORGANIZER': 'Organizer',
				'LINKED_PLACE': 'Linked place',
				'EVENT_SERIES_NAME': 'Event series name',
				'EVENT_DATE': 'Date',
				'INSTITUTION_TYPE': 'Type',
				'PRINCIPAL_TITLE': 'Title',
				'PERIOD_OF_ACTIVITY': 'Period of activity',
				'PLACE_OF_ACTIVITY': 'Place of activity',
				'ADDRESSEE': 'Addressee',
				'PHYSICAL_DESCRIPTION': 'Physical description',
				'CO_CREATION_TYPE': 'Cocreation type',
				'LINKED_SERIES': 'Linked series',
				'PREMIERE_THEATER': 'Premiere theater',
				'LINKED_EVENT': 'Linked event',
				'LANGUAGE': 'Language',
				'LAUREATE': 'Laureate',
				'RECORD_FORM': 'Form',
				'RECORD_TYPE': 'Type',
				'RECORD_PLACE': 'Place',
				'CO_CREATOR': 'Cocreator',
				'RECORD_YEAR': 'Year',
				'FILM_STUDIO': 'Film studio',
				'TRIGGER_INSTITUTION': 'Trigger institution',
				'BELONGING_TO_SERIES': 'Belonging to series',
				'RECORD_SOURCE': 'Source',
				'LINKED_RECORD': 'Linked record',
				'LINKED_CREATIVE_WORK': 'Linked creative work',
				'LINKED_PUBLISHING_SERIES': 'Linked publishing series',
				'SENDER': 'Sender',
				'INTERVIEWER': 'Interviewer',
				'INTERLOCUTOR': 'Interlocutor',
				'CHAPTER_TITLE': 'Domain title',
				'ANTHOLOGY_DESCRIPTION': 'Anthology description',
				'BOOK_EDITION': 'Book edition',
				'EXTERNAL_LINK': 'External links',
				'AUTHOR': 'Author',
				'CREATOR': 'Creator',
				'ABBREVIATION': 'Abbreviation',
				'PUBLISHED_IN_SERIES': 'Published in series',
				'PUBLISHED_FROM': 'Published from',
				'PUBLISHED_TO': 'Published to',
				'PUBLISHING_PLACE': 'Publishing place',
				'ISSN': 'ISSN',
				'LIBRARY': 'Library',
				'SIGNATURE': 'Signature',
				'contains': 'contains',
				'not_contains': 'does not contain',
				'contains_anything': 'contains anything',
				'is_empty': 'is empty',
				'CONTAINS': 'contains',
				'NOT_CONTAINS': 'does not contain',
				'CONTAINS_ANYTHING': 'contains anything',
				'IN_RANGE': 'is in range',
				'in_range': 'is in range',
				'IS_EMPTY': 'is empty',
				'YEAR_FROM': 'Year from',
				'YEAR_TO': 'Year to',
				'ITEM_FROM': 'Material from',
				'ITEM_TO': 'Material to',
				'CHARACTER': 'Character',
				'RELATION': 'Related to',
				'NAME': 'Name',
				'DATE_FROM': 'Date from',
				'DATE_TO': 'Date to',
				'EDITION_OF': 'Edition',
				'LOCATION': 'Location',
				'and': 'and',
				'or': 'or',
				'AND': 'and',
				'OR': 'or',
			},
			'relation': 'Relation',
			'query': 'Query',
			'date_from': 'Date from',
			'date_to': 'Date to',
			'dates_from': 'from',
			'dates_to': 'to',
			'add_fields': 'Add search criterion',
			'add_field': 'Add value',
			'remove_field': 'Remove value',
			'remove_fields': 'Add search criterion',
			'phraze': 'Enter word or phrase',
			'select_phraze': 'Select phrase',
			'search_field': 'Attribute',
			'how': 'How to search and read results?',
			'key': 'Query object',
			'select_attribute': 'Select attribute...',
			'and': 'and',
		},
		advanced_search_results: {
			'change_query': 'Change query',
			'results_number': 'Number of results',
		},
		field_types: {
			'polish-literature': 'Polish literature',
			'literature-theory': 'Theory of literature',
			'foreign-literature': 'Foreign literatures',
			'movie-theatre-rtv': 'Theater, film, radio, and television'
		},
		characteristics: {
			'records': 'Characteristic of PBL records',
			'files': 'Characteristic of PBL files',
			'headings': 'Characteristic of PBL domains and subjects headings',
			'headings_structure': '<strong>Structure</strong> of PBL domains and subjects headings',
			'heading': 'Domain',
			'heading_structure': 'Domain structure',
			'headings_results': 'Search in the name of the department',
			'literature-theory': 'Theory of literature',
			'polish-literature': 'Polish literature',
			'foreign-literature': 'Foreign literatures',
			'movie-theatre-rtv': 'Theater, film, theater, radio and television ',
			'show_structure': 'Show structure',
			'hide_structure': 'Hide structure',
			'show_description': 'Show description',
			'hide_description': 'Hide description',
			'go_to_file': 'Go to file',
			'go_to_record': 'See records',
			'all_records': 'See all records',
			'field_desc': 'Domain description',
			'contact': 'Contact',
			'error': 'Error. Content cannot be displayed',
			'search': 'enter word or phrase',
			'search_in': 'Search subjects headings',
			'search_results_title': '<strong>Results of search</strong> in the PBL domains and subjects headings',
			'no_results': 'no results',
			'in': 'in',
			'show_all_from_field': 'Show all for this domain',
			'special_topic': 'Special topic',
		},
		headings_details: {
			'content': "Subject heading <strong>contents</strong>",
			'content_desc': "This subject heading contains both general materials connected with honorary doctorates and those connected with specific institutions that granted them and the individuals awarded. To browse the content of a subject heading select the topic of interest. The materials have been categorized and grouped to facilitate browsing.",
			'desc': 'Subject heading <strong>description</strong>',
			'location': 'Subject heading <strong>location</strong>',
			'show_details': 'Go to section',
			'domain': 'Domain',
			'heading': 'Subject heading',
			'change_domain': 'Change domain',
			'contact': 'Contact the editor of the department',
			'error': 'Report an error to the editor',
			'choose': 'Choose',
			'go_to': 'Go to',
			'go_to_dest': {
				'journal': 'journal cards',
				'person': 'person cards',
				'institution': 'institutions cards',
				'journals': 'journals cards',
				'event': 'events cards',
				'event-series': 'events series cards',
				'publishing_house': 'publishing houses cards',
			},
			'ALL_JOURNALS': 'All journals',
			'GENERAL_MATERIALS_GENERAL_MATERIAL': 'General material',
			'LITERARY_GENETICS_GENERAL_MATERIAL': 'General material',
			'LITERARY_GENETICS_MATERIALS_FOR_DICTIONARY': 'Material for dictionary',
			'JOURNAL_GENERAL_MATERIAL': 'Journal general material',
			'MATERIALS_ABOUT_JOURNAL': 'Materials about journal',
			'MATERIALS_ABOUT_JOURNAL_SINGLE': 'Materials about journal',
			'ACTIVITY_OF_JOURNAL': 'Activity of journal',
			'ACTIVITY_OF_JOURNAL_SINGLE': 'Activity of journal',
			'LITERARY_TEXT': 'Text',
			'STUDY_TEXT': 'Study text',
			'CREATIVE_WRITING_GENERAL_MATERIAL': 'General material',
			'CREATIVE_WRITING_LITERARY_COUNSELING': 'Literary counseling',
			'BIBLE_TEXT': 'Text',
			'BIBLE_STUDY_TEXT': 'Study text',
			'ALL_INSTITUTIONS': 'All institutions',
			'INSTITUTION_GENERAL_MATERIAL': 'General material',
			'MATERIALS_ABOUT_INSTITUTION': 'Materials about institution',
			'MATERIALS_ABOUT_INSTITUTION_SINGLE': 'Materials about institution',
			'ACTIVITY_OF_INSTITUTION': 'Activity of institution',
			'ACTIVITY_OF_INSTITUTION_SINGLE': 'Activity of institution',
			'ALL_PUBLISHING_HOUSES': 'All publishing houses',
			'PUBLISHING_HOUSE_GENERAL_MATERIAL': 'General material',
			'MATERIALS_ABOUT_PUBLISHING_HOUSE': 'Materials about',
			'MATERIALS_ABOUT_PUBLISHING_HOUSE_SINGLE': 'Materials about',
			'ACTIVITY_OF_PUBLISHING_HOUSE': 'Activity of publishing house',
			'ACTIVITY_OF_PUBLISHING_HOUSE_SINGLE': 'Activity of publishing house',
			'ALL_EVENTS': 'All events',
			'EVENT_GENERAL_MATERIAL': 'General material',
			'MATERIALS_ABOUT_EVENT': 'Materials about event',
			'MATERIALS_ABOUT_EVENT_SINGLE': 'Materials about event',
			'LINKED_EVENTS': 'Linked events',
			'LINKED_EVENTS_SINGLE': 'Linked events',
			'FEATURE_MOVIE_TYPE': 'Feature',
			'TV_MOVIE_TYPE': 'TV',
			'DOCUMENTARY_MOVIE_TYPE': 'Documentary',
			'SERIES_MOVIE_TYPE': 'Series',
			'LITERARY_LIFE_NATIONWIDE_CULTURAL_EVENTS': 'Cultural events',
			'LITERARY_LIFE_NATIONWIDE_CULTURAL_INSTITUTIONS': 'Cultural institutions',
			'LITERARY_LIFE_NATIONWIDE_GENERAL_MATERIAL': 'General material',
			'TEXT_STUDIES': 'Text studies',
			'LITERARY_LIFE_IN_CENTERS_ALL_PLACES': 'All places',
			'LITERARY_LIFE_IN_CENTERS_GENERAL_MATERIAL': 'General material',
			'LITERARY_LIFE_IN_CENTERS_GENERAL_MATERIAL_FOR_PLACE': 'General material',
			'LITERARY_LIFE_IN_CENTERS_GENERAL_MATERIAL_FOR_PLACE_SINGLE': 'General material',
			'LITERARY_LIFE_IN_CENTERS_CULTURAL_EVENTS': 'Cultural events in place',
			'LITERARY_LIFE_IN_CENTERS_CULTURAL_EVENTS_SINGLE': 'Cultural events in place',
			'LITERARY_LIFE_IN_CENTERS_CULTURAL_INSTITUTIONS': 'Cultural institutions in place',
			'LITERARY_LIFE_IN_CENTERS_CULTURAL_INSTITUTIONS_SINGLE': 'Cultural institutions in place',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_ALL_COUNTRIES': 'All countries',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_GENERAL_MATERIAL': 'General material',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_GENERAL_MATERIAL_FOR_COUNTRY': 'General material',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_GENERAL_MATERIAL_FOR_COUNTRY_SINGLE': 'General material',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_EVENTS': 'Events',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_EVENTS_SINGLE': 'Events',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_INSTITUTIONS': 'Institutions',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_INSTITUTIONS_SINGLE': 'Institutions',
			'ALL_PEOPLE': 'All people',
			'PERSON_GENERAL_MATERIAL': 'General material',
			'PERSON_AUTHORSHIP': 'Authorship',
			'PERSON_AUTHORSHIP_SINGLE': 'Authorship',
			'PERSON_CO_CREATION': 'Cocreation',
			'PERSON_CO_CREATION_SINGLE': 'Cocreation',
			'PERSON_ACTIVITY': 'Materials about person and its activities',
			'PERSON_ACTIVITY_SINGLE': 'Materials about person and its activities',
			'PERSON_EVENTS': 'Participation in events',
			'PERSON_EVENTS_SINGLE': 'Participation in events',
			'PERSON_WORSHIP': 'Manifestations of worship',
			'PERSON_WORSHIP_SINGLE': 'Manifestations of worship',
			'PERSON_MENTION': 'Mention',
			'PERSON_MENTION_SINGLE': 'Mention',
			'HC_DOCTORATES_GENERAL_MATERIAL': 'General material',
			'HC_DOCTORATES_DOCTORATES': 'Honoris causa doctorates',
			'HC_DOCTORATES_DOCTORATES_SINGLE': 'Honoris causa doctorates',
			'HC_DOCTORATES_MATERIALS_ABOUT_DOCTORATES': 'Reports, discussions, laudations',
			'HC_DOCTORATES_MATERIALS_ABOUT_DOCTORATES_SINGLE': 'Reports, discussions, laudations',
			'THEATERS_IN_COUNTRY_ALL_THEATERS': 'List of theaters',
			'THEATERS_IN_COUNTRY_ALL_PLACES': 'List of cities',
			'THEATERS_IN_COUNTRY_GENERAL_MATERIAL': 'General material',
			'THEATERS_IN_COUNTRY_ACTIVITY_OF_THEATER': 'Discussion of theaters activities',
			'THEATERS_IN_COUNTRY_ACTIVITY_OF_THEATER_SINGLE': 'Discussion of theater activities',
			'THEATERS_IN_COUNTRY_REPERTOIRE': 'Theaters repertoire',
			'THEATERS_IN_COUNTRY_REPERTOIRE_SINGLE': 'Theater repertoire',
			'THEATERS_ABROAD_ALL_THEATERS': 'List of theaters',
			'THEATERS_ABROAD_ALL_COUNTRIES': 'List of countries',
			'THEATERS_ABROAD_GENERAL_MATERIAL': 'General material',
			'THEATERS_ABROAD_ACTIVITY_OF_THEATER': 'Discussion of theaters activities',
			'THEATERS_ABROAD_ACTIVITY_OF_THEATER_SINGLE': 'Discussion of theater activities',
			'THEATERS_ABROAD_REPERTOIRE': 'Theaters repertoire',
			'THEATERS_ABROAD_REPERTOIRE_SINGLE': 'Theater repertoire',
			'FOREIGN_THEATER_ALL_COUNTRIES': 'List of countries',
			'FOREIGN_THEATER_GENERAL_MATERIAL': 'General material',
			'CONTEMPORARY_REALIZATIONS_OF_POLISH_DRAMA_ABROAD_GENERAL_MATERIAL': 'General material',
			'CONTEMPORARY_REALIZATIONS_OF_POLISH_DRAMA_ABROAD_SPECTACLE': 'Spectacles',
			'THEATER_CONTACTS_WITH_FOREIGN_COUNTRIES_ALL_COUNTRIES': 'List of countries',
			'THEATER_CONTACTS_WITH_FOREIGN_COUNTRIES_ALL_THEATERS': 'List of theaters',
			'THEATER_CONTACTS_WITH_FOREIGN_COUNTRIES_GENERAL_MATERIAL': 'General material',
			'THEATER_CONTACTS_WITH_FOREIGN_COUNTRIES_GENERAL_MATERIAL_SINGLE': 'General material',
			'THEATER_CONTACTS_WITH_FOREIGN_COUNTRIES_SPECTACLE': 'Spectacles',
			'THEATER_CONTACTS_WITH_FOREIGN_COUNTRIES_SPECTACLE_SINGLE': 'Spectacles',

		},
		collections: {
			'about': 'Characteristic of PBL collections',
			'learn_more': 'Learn more',
			'in_brief': '<strong>In brief</strong> about the collections',
			'collection': 'Collection',
			'see_results': 'Go to collection',
		},
		item: {
			'annotation': 'Annotations',
			'no_info': 'No additional info.',
			'mainName': 'Proper surname',
			'otherName': 'Other form of surname or first name',
			'journalSubtitle': 'Subtitle',
			'authors': 'Author',
			'additionTo': 'Supplement to',
			'contains': 'Contains',
			'seriesType': 'Series type',
			'sources': 'Periodical source',
			'triggerInstitution': 'Causative institution',
			'publishingHouse': 'Publisher, publication place',
			'subtype': 'Institution type',
			'subtypeEventSeries': 'Event series type',
			'location': 'Operation place',
			'alias': 'Alias',
			'familyName': 'Family name',
			'monasticName': 'Religious name',
			'codename': 'Codename',
			'subtypeEvent': 'Event type',
			'edition': 'Edition',
			'locationAndDateEvent': 'Event place and date',
			'awards': 'Laureates',
			'organizors': 'Organizer',
			'release_date': 'Release date',
			'details': 'Record <strong>details</strong>',
			'details_card': 'Page <strong>details</strong>',
			'details_tab': 'Page details',
			'yearbook_desc': "Edited year's issues",
			'yearbook_desc_header': "Edited <strong>year's issues</strong>",
			'yearbook_desc_tab': "Edited year's issues",
			'bib_desc': '<strong>Bibliographical</strong> description',
			'external_links': 'External <strong>links</strong>',
			'provenance': 'Information <strong>provenance</strong>',
			'related_records': '<strong>Related</strong> records and files',
			'see_related': 'See visualization of relations to other objects in PBL database',
			'phrase': 'Phrase in field',
			'not_found': 'Object not found',
			'next': 'Next',
			'prev': 'Previous',

			"eventseries.linkedCreativeWorks.authorsForSearch": "Material connected with work",
			"eventseries.creator": "Creator",
			"eventseries.linkedRecordsTitles": "Material connected with records",
			"eventseries.linkedCreativeWorks.titles.title": "Material connected with work",
			"eventseries.innerTags.name": "Name",
			"eventseries.linkedSeries.authorsForSearch": "Material connected with series",
			"eventseries.linkedPlacesForSearch": "Material connected with places",
			"eventseries.materialsAboutInstitution": "Material about institutions",
			"eventseries.linkedEventsForSearch": "Material connected with events",
			"eventseries.annotations": "Annotations",
			"eventseries.eventHeadings": "Headings",
			"eventseries.history.names.name": "Name",
			"eventseries.externalLinks.url": "External links",
			"eventseries.eventTypeForSearch": "Event type",
			"eventseries.linkedSeries.titles.title": "Material connected with series",
			"eventseries.organizers": "Organizer",
			"eventseries.materialsAboutJournal": "Material about journal",
			"eventseries.remarks": "Remarks",
			"eventseries.originSources": "Sources",
			"movie.linkedCreativeWorks.authorsForSearch": "Material connected with work",
			"movie.linkedRecordsTitles": "Material connected with records",
			"movie.typesForSearch": "Type",
			"movie.materialsAboutInstitution": "Material about institutions",
			"movie.recordHeadings": "Headings",
			"movie.annotations": "Annotations",
			"movie.coCreations.coCreators": "Cocreators",
			"movie.titles.title": "Titles",
			"movie.years": "Year",
			"movie.externalLinks.url": "External links",
			"movie.linkedSeries.titles.title": "Material connected with series",
			"movie.materialsAboutEvent": "Material about events",
			"movie.triggerInstitutions.history.names.name": "Causative institution",
			"movie.materialsAboutJournal": "Material about journals",
			"movie.principalTitle": "Base title",
			"movie.creator": "Creator",
			"movie.linkedCreativeWorks.titles.title": "Material connected with work",
			"movie.innerTags.name": "Name",
			"movie.linkedSeries.authorsForSearch": "Material connected with series",
			"movie.collectionsForSearch": "Collections",
			"movie.filmStudios.history.names.name": "Studio",
			"movie.persons": "Person and their functions",
			"movie.places": "Place",
			"movie.recordForm": "Record form",
			"movie.coCreationTypes": "Co-Creation types",
			"movie.remarks": "Remarks",
			"movie.originSources": "Sources",
			"spectacle.linkedCreativeWorks.authorsForSearch": "Material connected with work",
			"spectacle.creator": "Creator",
			"spectacle.linkedRecordsTitles": "Material connected with records",
			"spectacle.linkedCreativeWorks.titles.title": "Material connected with work",
			"spectacle.innerTags.name": "Name",
			"spectacle.linkedSeries.authorsForSearch": "Material connected with series",
			"spectacle.typesForSearch": "Type",
			"spectacle.materialsAboutInstitution": "Material about instutions",
			"spectacle.recordHeadings": "Headings",
			"spectacle.annotations": "Annotations",
			"spectacle.collectionsForSearch": "Collections",
			"spectacle.coCreations.coCreators": "Cocreators",
			"spectacle.titles.title": "Titles",
			"spectacle.years": "Year",
			"spectacle.persons": "Person and their functions",
			"spectacle.externalLinks.url": "External links",
			"spectacle.recordForm": "Record form",
			"spectacle.coCreationTypes": "Co-Creation types",
			"spectacle.premiereDescription.theater.history.names.name": "Theater",
			"spectacle.linkedSeries.titles.title": "Material connected with series",
			"spectacle.materialsAboutEvent": "Material about events",
			"spectacle.principalTitle": "Basic title",
			"spectacle.remarks": "Remarks",
			"spectacle.originSources": "Sources",
			"radiotelevision.linkedCreativeWorks.authorsForSearch": "Material connected with work",
			"radiotelevision.linkedRecordsTitles": "Material connected with records",
			"radiotelevision.typesForSearch": "Type",
			"radiotelevision.materialsAboutInstitution": "Material about institutions",
			"radiotelevision.recordHeadings": "Headings",
			"radiotelevision.annotations": "Annotations",
			"radiotelevision.coCreations.coCreators": "Cocreators",
			"radiotelevision.titles.title": "Titles",
			"radiotelevision.years": "Year",
			"radiotelevision.externalLinks.url": "External links",
			"radiotelevision.linkedSeries.titles.title": "Material connected with series",
			"radiotelevision.materialsAboutEvent": "Material about events",
			"radiotelevision.materialsAboutJournal": "Material about journals",
			"radiotelevision.principalTitle": "Base title",
			"radiotelevision.creator": "Creator",
			"radiotelevision.linkedCreativeWorks.titles.title": "Material connected with work",
			"radiotelevision.innerTags.name": "Name",
			"radiotelevision.linkedSeries.authorsForSearch": "Material connected with series",
			"radiotelevision.collectionsForSearch": "Collections",
			"radiotelevision.belongingToSeries.titles.title": "Event series",
			"radiotelevision.persons": "Person and their functions",
			"radiotelevision.places": "Place",
			"radiotelevision.recordForm": "Record form",
			"radiotelevision.coCreationTypes": "Co-Creation types",
			"radiotelevision.remarks": "Remarks",
			"radiotelevision.originSources": "Sources",
			"journalitem.linkedCreativeWorks.authorsForSearch": "Material connected with work",
			"journalitem.linkedRecordsTitles": "Material connected with records",
			"journalitem.sources": "Source",
			"journalitem.typesForSearch": "Type",
			"journalitem.materialsAboutInstitution": "Material about instutions",
			"journalitem.recordHeadings": "Headings",
			"journalitem.annotations": "Annotations",
			"journalitem.coCreations.coCreators": "Cocreators",
			"journalitem.titles.title": "Titles",
			"journalitem.years": "Year",
			"journalitem.externalLinks.url": "External links",
			"journalitem.linkedSeries.titles.title": "Material connected with series",
			"journalitem.materialsAboutEvent": "Material about events",
			"journalitem.materialsAboutJournal": "Material about journals",
			"journalitem.principalTitle": "Base title",
			"journalitem.creator": "Creator",
			"journalitem.linkedCreativeWorks.titles.title": "Material connected with work",
			"journalitem.innerTags.name": "Name",
			"journalitem.linkedSeries.authorsForSearch": "Material connected with series",
			"journalitem.languagesForSearch": "Language",
			"journalitem.collectionsForSearch": "Collections",
			"journalitem.linkedPublishingSeries.titles.title": "Material connected with publishing series",
			"journalitem.belongingToSeries.titles.title": "Event series",
			"journalitem.persons": "Person and their functions",
			"journalitem.places": "Place",
			"journalitem.recordForm": "Record form",
			"journalitem.anthologyDescription": "Anthology description",
			"journalitem.coCreationTypes": "Co-Creation types",
			"journalitem.remarks": "Remarks",
			"journalitem.originSources": "Sources",
			"authorsbook.linkedCreativeWorks.authorsForSearch": "Material connected with work",
			"authorsbook.linkedRecordsTitles": "Material connected with records",
			"authorsbook.typesForSearch": "Type",
			"authorsbook.materialsAboutInstitution": "Material about instutions",
			"authorsbook.recordHeadings": "Headings",
			"authorsbook.annotations": "Annotations",
			"authorsbook.edition": "Edition",
			"authorsbook.coCreations.coCreators": "Cocreators",
			"authorsbook.titles.title": "Titles",
			"authorsbook.years": "Year",
			"authorsbook.externalLinks.url": "External links",
			"authorsbook.linkedSeries.titles.title": "Material connected with series",
			"authorsbook.materialsAboutEvent": "Material about events",
			"authorsbook.triggerInstitutions.history.names.name": "Causative institution",
			"authorsbook.materialsAboutJournal": "Material about journals",
			"authorsbook.principalTitle": "Base title",
			"authorsbook.creator": "Creator",
			"authorsbook.linkedCreativeWorks.titles.title": "Material connected with work",
			"authorsbook.innerTags.name": "Name",
			"authorsbook.linkedSeries.authorsForSearch": "Material connected with series",
			"authorsbook.languagesForSearch": "Language",
			"authorsbook.collectionsForSearch": "Collections",
			"authorsbook.linkedPublishingSeries.titles.title": "Material connected with publishing series",
			"authorsbook.physicalDescription.description": "Description",
			"authorsbook.belongingToSeries.titles.title": "Series",
			"authorsbook.persons": "Person and their functions",
			"authorsbook.places": "Place",
			"authorsbook.recordForm": "Record form",
			"authorsbook.coCreationTypes": "Co-Creation types",
			"authorsbook.remarks": "Remarks",
			"authorsbook.originSources": "Sources",
			"collectivebook.linkedCreativeWorks.authorsForSearch": "Material connected with work",
			"collectivebook.linkedRecordsTitles": "Material connected with records",
			"collectivebook.typesForSearch": "Type",
			"collectivebook.materialsAboutInstitution": "Material about instutions",
			"collectivebook.recordHeadings": "Headings",
			"collectivebook.annotations": "Annotations",
			"collectivebook.edition": "Edition",
			"collectivebook.coCreations.coCreators": "Cocreators",
			"collectivebook.titles.title": "Titles",
			"collectivebook.years": "Year",
			"collectivebook.externalLinks.url": "External links",
			"collectivebook.linkedSeries.titles.title": "Material connected with series",
			"collectivebook.materialsAboutEvent": "Material about events",
			"collectivebook.triggerInstitutions.history.names.name": "Causative institution",
			"collectivebook.materialsAboutJournal": "Material about journals",
			"collectivebook.principalTitle": "Base title",
			"collectivebook.creator": "Creator",
			"collectivebook.linkedCreativeWorks.titles.title": "Material connected with work",
			"collectivebook.innerTags.name": "Name",
			"collectivebook.linkedSeries.authorsForSearch": "Material connected with series",
			"collectivebook.languagesForSearch": "Language",
			"collectivebook.collectionsForSearch": "Collections",
			"collectivebook.linkedPublishingSeries.titles.title": "Material connected with publishing series",
			"collectivebook.physicalDescription.description": "Description",
			"collectivebook.belongingToSeries.titles.title": "Series",
			"collectivebook.persons": "Person and their functions",
			"collectivebook.places": "Place",
			"collectivebook.recordForm": "Record form",
			"collectivebook.coCreationTypes": "Co-Creation types",
			"collectivebook.remarks": "Remarks",
			"collectivebook.originSources": "Sources",
			"anthology.linkedCreativeWorks.authorsForSearch": "Material connected with work",
			"anthology.linkedRecordsTitles": "Material connected with records",
			"anthology.typesForSearch": "Type",
			"anthology.materialsAboutInstitution": "Material about instutions",
			"anthology.recordHeadings": "Headings",
			"anthology.annotations": "Annotations",
			"anthology.edition": "Edition",
			"anthology.coCreations.coCreators": "Cocreators",
			"anthology.titles.title": "Titles",
			"anthology.years": "Year",
			"anthology.externalLinks.url": "External links",
			"anthology.linkedSeries.titles.title": "Material connected with series",
			"anthology.materialsAboutEvent": "Material about events",
			"anthology.triggerInstitutions.history.names.name": "Causative institution",
			"anthology.materialsAboutJournal": "Material about journals",
			"anthology.principalTitle": "Base title",
			"anthology.creator": "Creator",
			"anthology.linkedCreativeWorks.titles.title": "Material connected with work",
			"anthology.innerTags.name": "Name",
			"anthology.linkedSeries.authorsForSearch": "Material connected with series",
			"anthology.languagesForSearch": "Language",
			"anthology.collectionsForSearch": "Collections",
			"anthology.linkedPublishingSeries.titles.title": "Material connected with publishing series",
			"anthology.physicalDescription.description": "Description",
			"anthology.belongingToSeries.titles.title": "Series",
			"anthology.persons": "Person and their functions",
			"anthology.places": "Place",
			"anthology.recordForm": "Record form",
			"anthology.coCreationTypes": "Co-Creation types",
			"anthology.remarks": "Remarks",
			"anthology.originSources": "Sources",
			"letters.linkedCreativeWorks.authorsForSearch": "Material connected with work",
			"letters.linkedRecordsTitles": "Material connected with records",
			"letters.typesForSearch": "Type",
			"letters.materialsAboutInstitution": "Material about instutions",
			"letters.recordHeadings": "Headings",
			"letters.annotations": "Annotations",
			"letters.edition": "Edition",
			"letters.coCreations.coCreators": "Cocreators",
			"letters.titles.title": "Titles",
			"letters.years": "Year",
			"letters.externalLinks.url": "External links",
			"letters.linkedSeries.titles.title": "Material connected with series",
			"letters.materialsAboutEvent": "Material about events",
			"letters.triggerInstitutions.history.names.name": "Causative institution",
			"letters.materialsAboutJournal": "Material about journals",
			"letters.principalTitle": "Base title",
			"letters.creator": "Creator",
			"letters.linkedCreativeWorks.titles.title": "Material connected with work",
			"letters.innerTags.name": "Name",
			"letters.linkedSeries.authorsForSearch": "Material connected with series",
			"letters.languagesForSearch": "Language",
			"letters.collectionsForSearch": "Collections",
			"letters.linkedPublishingSeries.titles.title": "Material connected with publishing series",
			"letters.physicalDescription.description": "Description",
			"letters.belongingToSeries.titles.title": "Series",
			"letters.persons": "Person and their functions",
			"letters.places": "Place",
			"letters.recordForm": "Record form",
			"letters.coCreationTypes": "Co-Creation types",
			"letters.remarks": "Remarks",
			"letters.originSources": "Sources",
			"person.placeOfBirth": "Place of birth",
			"person.creator": "Creator",
			"person.innerTags.name": "Name",
			"person.dateOfDeath": "Date of death",
			"person.annotations": "Annotations",
			"person.dateOfBirth": "Date of birth",
			"person.placeOfDeath": "Place of death",
			"person.personSex": "Sex",
			"person.yearOfDeath": "Year of death",
			"person.externalLinks.url": "External links",
			"person.personHeadings": "Headings",
			//   "person.names.name": "Persons names",
			"person.remarks": "Remarks",
			"person.yearOfBirth": "Year of birth",
			"person.originSources": "Sources",
			"person.names.name": "Name",
			"creativework.titles.title": "Titles",
			"creativework.annotations": "Annotations",
			"creativework.authorsForSearch": "Author",
			"journal.yearbooks": "Years issue",
			"journal.creator": "Creator",
			"journal.innerTags.name": "Name",
			"journal.libraries": "Libraries",
			"journal.annotations": "Annotations",
			"journal.abbreviation": "Abbreviation",
			"journal.titles.title": "Titles",
			"journal.publishedTo": "Published to",
			"journal.signatures": "Signatures",
			"journal.publishedFrom": "Published from",
			"journal.externalLinks.url": "External links",
			"journal.publishingPlaces": "Place of publication",
			"journal.issn": "ISSN",
			"journal.publishedInSeries": "Published in series",
			"journal.journalHeadings": "Headings",
			"journal.remarks": "Remarks",
			"journal.originSources": "Sources",
			"event.linkedCreativeWorks.authorsForSearch": "Material connected with work",
			"event.linkedRecordsTitles": "Material connected with records",
			"event.linkedPlacesForSearch": "Material connected with places",
			"event.materialsAboutInstitution": "Material about instutions",
			"event.linkedEventsForSearch": "Material connected with events",
			"event.annotations": "Annotations",
			"event.belongingToEventSeries.history.names.name": "Material connected with event series",
			"event.externalLinks.url": "External links",
			"event.eventTypeForSearch": "Event type",
			"event.dateForSearch": "Date",
			"event.linkedSeries.titles.title": "Material connected with series",
			"event.names.name": "Name",
			"event.laureates": "Laureate",
			"event.materialsAboutJournal": "Material about journal",
			"event.period": "For period",
			"event.creator": "Creator",
			"event.linkedCreativeWorks.titles.title": "Material connected with work",
			"event.innerTags.name": "Name",
			"event.linkedSeries.authorsForSearch": "Material connected with series",
			"event.eventHeadings": "Headings",
			"event.editionNumber": "Event edition number",
			"event.places": "Event place",
			"event.organizers": "Organizer",
			"event.remarks": "Remarks",
			"event.originSources": "Sources",
			"institution.externalLinks.url": "External links",
			"institution.places": "Operation place",
			"institution.creator": "Creator",
			"institution.yearOfInstitution": "Operation period",
			"institution.innerTags.name": "Name",
			"institution.institutionTypes": "Institution types",
			"institution.annotations": "Annotations",
			"institution.history.names.name": "Name",
			"institution.institutionHeadings": "Headings",
			"institution.remarks": "Remarks",
			"institution.originSources": "Sources",
			"series.creator": "Creator",
			"series.innerTags.name": "Name",
			"series.interviewers": "Interviewers",
			"series.authorsForSearch": "Authors",
			"series.annotations": "Annotations",
			"series.titles.title": "Titles",
			"series.sourcesForSearch": "Source",
			"series.persons": "Person and their functions",
			"series.addressees": "Addressees",
			"series.externalLinks.url": "External links",
			"series.formForSearch": "Form",
			"series.senders": "Senders",
			"series.interlocutors": "Interlocutors",
			"series.seriesHeadings": "Headings",
			"series.remarks": "Remarks",
			"series.seriesTypeForSearch": "Series type",
			"series.originSources": "Sources",
			"publishingseries.annotations": "Annotation",
			"publishingseries.principalTitle": "Title",
			"publishingseries.remarks": "Remarks",
			"collectivebookcontent.linkedCreativeWorks.authorsForSearch": "Material connected with work",
			"collectivebookcontent.linkedRecordsTitles": "Material connected with records",
			"collectivebookcontent.typesForSearch": "Type",
			"collectivebookcontent.interviewers": "Interviewers",
			"collectivebookcontent.materialsAboutInstitution": "Material about instutions",
			"collectivebookcontent.recordHeadings": "Headings",
			"collectivebookcontent.annotations": "Annotations",
			"collectivebookcontent.coCreations.coCreators": "Cocreators",
			"collectivebookcontent.titles.title": "Titles",
			"collectivebookcontent.years": "Year",
			"collectivebookcontent.externalLinks.url": "External links",
			"collectivebookcontent.linkedSeries.titles.title": "Material connected with series",
			"collectivebookcontent.materialsAboutEvent": "Material about events",
			"collectivebookcontent.materialsAboutJournal": "Material about journals",
			"collectivebookcontent.chapterTitles.title": "Chapter title",
			"collectivebookcontent.principalTitle": "Base title",
			"collectivebookcontent.senders": "Senders",
			"collectivebookcontent.interlocutors": "Interlocutors",
			"collectivebookcontent.creator": "Creator",
			"collectivebookcontent.linkedCreativeWorks.titles.title": "Material connected with work",
			"collectivebookcontent.innerTags.name": "Name",
			"collectivebookcontent.linkedSeries.authorsForSearch": "Material connected with series",
			"collectivebookcontent.languagesForSearch": "Language",
			"collectivebookcontent.collectionsForSearch": "Collections",
			"collectivebookcontent.linkedPublishingSeries.titles.title": "Material connected with publishing series",
			"collectivebookcontent.persons": "Person and their functions",
			"collectivebookcontent.addressees": "Addressees",
			"collectivebookcontent.places": "Place",
			"collectivebookcontent.recordForm": "Record form",
			"collectivebookcontent.anthologyDescription": "Anthology description",
			"collectivebookcontent.coCreationTypes": "Co-Creation types",
			"collectivebookcontent.remarks": "Remarks",
			"collectivebookcontent.originSources": "Sources",
			"anthologycontent.linkedCreativeWorks.authorsForSearch": "Material connected with work",
			"anthologycontent.linkedRecordsTitles": "Material connected with records",
			"anthologycontent.typesForSearch": "Type",
			"anthologycontent.interviewers": "Interviewers",
			"anthologycontent.materialsAboutInstitution": "Material about instutions",
			"anthologycontent.recordHeadings": "Headings",
			"anthologycontent.annotations": "Annotations",
			"anthologycontent.coCreations.coCreators": "Cocreators",
			"anthologycontent.titles.title": "Titles",
			"anthologycontent.years": "Year",
			"anthologycontent.externalLinks.url": "External links",
			"anthologycontent.linkedSeries.titles.title": "Material connected with series",
			"anthologycontent.materialsAboutEvent": "Material about events",
			"anthologycontent.materialsAboutJournal": "Material about journal",
			"anthologycontent.chapterTitles.title": "Chapter title",
			"anthologycontent.principalTitle": "Base title",
			"anthologycontent.senders": "Senders",
			"anthologycontent.interlocutors": "Interlocutors",
			"anthologycontent.creator": "Creator",
			"anthologycontent.linkedCreativeWorks.titles.title": "Material connected with work",
			"anthologycontent.innerTags.name": "Name",
			"anthologycontent.linkedSeries.authorsForSearch": "Material connected with series",
			"anthologycontent.languagesForSearch": "Language",
			"anthologycontent.collectionsForSearch": "Collections",
			"anthologycontent.linkedPublishingSeries.titles.title": "Material connected with publishing series",
			"anthologycontent.persons": "Person and their functions",
			"anthologycontent.addressees": "Addressees",
			"anthologycontent.places": "Place",
			"anthologycontent.recordForm": "Record form",
			"anthologycontent.anthologyDescription": "Anthology description",
			"anthologycontent.coCreationTypes": "Co-Creation types",
			"anthologycontent.remarks": "Remarks",
			"anthologycontent.originSources": "Sources",
			"authorsbookcontent.linkedCreativeWorks.authorsForSearch": "Material connected with work",
			"authorsbookcontent.linkedRecordsTitles": "Material connected with records",
			"authorsbookcontent.typesForSearch": "Type",
			"authorsbookcontent.interviewers": "Interviewers",
			"authorsbookcontent.materialsAboutInstitution": "Material about instutions",
			"authorsbookcontent.recordHeadings": "Headings",
			"authorsbookcontent.annotations": "Annotations",
			"authorsbookcontent.coCreations.coCreators": "Cocreators",
			"authorsbookcontent.titles.title": "Titles",
			"authorsbookcontent.years": "Year",
			"authorsbookcontent.externalLinks.url": "External links",
			"authorsbookcontent.linkedSeries.titles.title": "Material connected with series",
			"authorsbookcontent.materialsAboutEvent": "Material about events",
			"authorsbookcontent.materialsAboutJournal": "Material about journals",
			"authorsbookcontent.chapterTitles.title": "Chapter title",
			"authorsbookcontent.principalTitle": "Base title",
			"authorsbookcontent.senders": "Senders",
			"authorsbookcontent.interlocutors": "Interlocutors",
			"authorsbookcontent.creator": "Creator",
			"authorsbookcontent.linkedCreativeWorks.titles.title": "Material connected with work",
			"authorsbookcontent.innerTags.name": "Name",
			"authorsbookcontent.linkedSeries.authorsForSearch": "Material connected with series",
			"authorsbookcontent.languagesForSearch": "Language",
			"authorsbookcontent.collectionsForSearch": "Collections",
			"authorsbookcontent.linkedPublishingSeries.titles.title": "Material connected with publishing series",
			"authorsbookcontent.persons": "Person and their functions",
			"authorsbookcontent.addressees": "Addressees",
			"authorsbookcontent.places": "Place",
			"authorsbookcontent.recordForm": "Record form",
			"authorsbookcontent.anthologyDescription": "Anthology description",
			"authorsbookcontent.coCreationTypes": "Co-Creation types",
			"authorsbookcontent.remarks": "Remarks",
			"authorsbookcontent.originSources": "Sources",
			"letterscontent.linkedCreativeWorks.authorsForSearch": "Material connected with work",
			"letterscontent.linkedRecordsTitles": "Material connected with records",
			"letterscontent.typesForSearch": "Type",
			"letterscontent.interviewers": "Interviewers",
			"letterscontent.materialsAboutInstitution": "Material about instutions",
			"letterscontent.recordHeadings": "Headings",
			"letterscontent.annotations": "Annotations",
			"letterscontent.coCreations.coCreators": "Cocreators",
			"letterscontent.titles.title": "Titles",
			"letterscontent.years": "Year",
			"letterscontent.externalLinks.url": "External links",
			"letterscontent.linkedSeries.titles.title": "Material connected with series",
			"letterscontent.materialsAboutEvent": "Material about events",
			"letterscontent.materialsAboutJournal": "Material about journal",
			"letterscontent.chapterTitles.title": "Chapter title",
			"letterscontent.principalTitle": "Base title",
			"letterscontent.senders": "Senders",
			"letterscontent.interlocutors": "Interlocutors",
			"letterscontent.creator": "Creator",
			"letterscontent.linkedCreativeWorks.titles.title": "Material connected with work",
			"letterscontent.innerTags.name": "Name",
			"letterscontent.linkedSeries.authorsForSearch": "Material connected with series",
			"letterscontent.languagesForSearch": "Language",
			"letterscontent.collectionsForSearch": "Collections",
			"letterscontent.linkedPublishingSeries.titles.title": "Material connected with publishing series",
			"letterscontent.persons": "Person and their functions",
			"letterscontent.addressees": "Addressees",
			"letterscontent.places": "Place",
			"letterscontent.recordForm": "Record form",
			"letterscontent.anthologyDescription": "Anthology description",
			"letterscontent.coCreationTypes": "Co-Creation types",
			"letterscontent.remarks": "Remarks",
			"letterscontent.originSources": "Sources",

			record: {
				'parent': 'Contained in',
				'journal': 'Periodical',
				'journal-item': 'Material in periodical',
				'journal-number': 'Periodical issue',
				'event-series': 'Events series',
				'institution': 'Institution',
				'series': 'Series',
				'place': 'Locality',
				'creative-work': 'Work',
				'event': 'Event',
				'movie': 'Movie',
				'authors-book': 'Book',
				'spectacle': 'Performance',
				'radio': 'Radio',
				'television': 'Television',
				'countries': 'Production',
				'publicationLanguage': 'Publication language',
				'annotations': 'Annotations',
				'coCreators': 'Co-creators',
				'title': 'Title',
				'titleOriginal': 'Original title',
				'titleOriginalLang': 'Original language',
				'translationBase': 'Translation base title',
				'translationBaseLang': 'Translation base language',
				'dedication': 'Dedication',
				'types': 'Record type',
				'locations': 'Publication place',
				'publicationYear': 'Publication year',
				'edition': 'Edition',
				'contents': 'Also contains',
				'publishingHouses': 'Publishing house',
				'typesAndKind': 'Record type',
				'radioType': 'Record type',
				'televisionType': 'Record type',
				'headings': 'Domain and subject heading',
				'secondaryHeadings': 'Domain and secondary subject heading',
				'linkedFilesAndRecords': 'Related to',
				'productionYear': 'Production year',
				'producersAndFilmStudios': 'Studio/producer',
				'triggerInstitutions': 'Causative institution',
				'collections': 'PBL Collection',
				'externalLinks': 'External identifier',
				'authors': 'Author',
				'physicalDescription': 'Physical description',
				'premiereYear': 'Premiere year',
				'belongingToSeries': 'Series',
				'anthologyDesc': 'Anthology content',
				'source': 'Other source',
				'sourceOrigin': 'Source',
				'authorCompany': 'Author',
				'theater': 'Theater',
				'resumptions': 'Restaging years',
				'premiere': 'Premiere year',
				'mailingParts': 'Correspondence pages',
				'interviewParts': 'Interview pages',
				'incipitTitle': 'Title (incipit)',
				'incipit': 'Incipit',
				'external-identifier': 'External identifier',
				'broader-description-access': 'Access more detailed description',
				'online-access': 'Online access',
				'other': 'Other',
				'partTitle': 'Part title',
				'chapterTitle': 'Domain title',
				'partDedication': 'Part dedication',
				'pagesRange': 'Pages',
				'belongingpublishingSeries': 'Series'
			},
			card: {
				'authors': 'Author',
				'title': 'Title',
				'baseTitle': 'Title',
				'translationBase': 'Translation base title',
				'translationBaseLang': 'Translation base language',
				'originalTitle': 'Original title',
				'titleOriginalLang': 'Original language',
				'incipit': 'Incipit',
				'otherTitleEvent': 'Other forms of event name',
				'otherTitle': 'Other forms of title',
				'contains': 'Consists',
				'previousTitle': 'Previous title',
				'nextTitle': 'Continuation',
				'publishedFromTo': 'Publication period',
				'typesEvent': 'Event type',
				'typesSeries': 'Series form and type',
				'edition': 'Edition',
				'mailingParts': 'Correspondence pages',
				'interviewParts': 'Interview pages',
				'sources': 'Source',
				'incipitTitle': 'Title (incipit:)',
				'locationsEvent': 'Event location',
				'dateEvent': 'Event date',
				'organizersEvent': 'Event organizer',
				'awards': 'Laureates',
				'belongingToEventSeries': 'Event series',
				'linkedFilesAndRecords': 'Regards',
				'headings': 'Domain and main subject heading',
				'secondaryHeadings': 'Domain and secondary subject heading',
				'annotations': 'Annotations',
				'external-identifier': 'External identifier',
				'broader-description-access': 'Access more detailed description',
				'online-access': 'Online access',
				'other': 'Other',
				'relationsEvent': 'Relation to other events',
				'parent': 'Consists in',
				'publicationFrequency': 'Publication frequency',
				'characters': 'Periodical character',
				'triggerInstitutions': 'Causative institution',
				'publishingHouses': 'Publishing house',
				'places': 'Publication place',
				'publishingSeries': 'Series',
				'issn': 'ISSN',
				'physicalDeficiencies': 'Physical deficiencies',
				'additionTo': 'Supplement to',
				'unitTitle': 'Individual title',
				'dedication': 'Dedication',
				'subordinate': 'Contains',
				'previous': 'Predecessor of',
				'next': 'Successor of',
				'relationPeriod': 'Period of relation to the above event',
				'mainName': 'Proper full name',
				'alias': 'Alias',
				'familyName': 'Family name',
				'monasticName': 'Religious name',
				'codename': 'Codename',
				'otherName': 'Other form of surname or first name',
				'groupAlias': 'Group alias',
				'authorCompany': 'Author partnership',
				'birthDate': 'Date of birth',
				'birthLocation': 'Place of birth',
				'deathDate': 'Date of death',
				'deathLocation': 'Place of death',
				'sex': 'Sex',
				'source': 'Other source',
				'sourceOrigin': 'Source',
				'journal': 'Periodical',
				'journal-item': 'Material in periodical',
				'journal-number': 'Periodical issue',
				'otherNames': 'Other forms of event series name',
				'otherNamesEventSeries': 'Period when the series used this name',
				'typesEventSeries': 'Event series type',
				'typesInstitution': 'Institution type',
				'organizers': 'Organizer',
				'relationsEventSeries': 'Relations to other event series',
				'namePeriodInfoCycle': 'Period when that series used this name',
				'namePeriodInfo': 'Period of operation under this name',
				'namePlaces': 'Operation place',
				'otherNamesPlacesInstitution': 'Place where the institution operated under this name',
				'otherNamesInstitution': 'Period when the institution operated under this name',
				'relationsInstitution': 'Relations with other institutions',
				'choose_heading': 'Select subject heading',
				'go_heading': 'Go to subject heading',
				'show_results': 'Show results',
				'heading_structure': "Domain's structure",
				'literature-theory': 'Literary theory',
				'polish-literature': 'Polish literature',
				'foreign-literature': 'Foreign literatures',
				'movie-theatre-rtv': 'Theater, film, radio and television',

				'in_heading': 'in subject heading',
				'person_in_heading': "Person",
				'institution_in_heading': 'Institution',
				'event-series_in_heading': 'Event series',
				'event_in_heading': 'Event',
				'creative-work_in_heading': 'Creative work',
				'journal-number_in_heading': 'Journal number',
				'journal_in_heading': 'Journal',
				'series_in_heading': 'Series',

				'person_in_heading_results': 'Go to <span>search results</span> concerning person:',
				'institution_in_heading_results': 'Go to <span>search results</span> concerning institution:',
				'event-series_in_heading_results': 'Go to <span>search results</span> concerning event series:',
				'event_in_heading_results': 'Go to <span>search results</span> concerning event:',
				'creative-work_in_heading_results': 'Go to <span>search results</span> concerning creative work:',
				'journal-number_in_heading_results': 'Go to <span>search results</span> concerning journal number:',
				'journal_in_heading_results': 'Go to <span>search results</span> concerning journal:',
				'series_in_heading_results': 'Go to <span>search results</span> concerning series:',
			},
			item_type: {
				'journal': 'Periodical',
				'journal-item': 'Material in periodical',
				'journal-number': 'Periodical issue',
				'event-series': 'Event series',
				'institution': 'Institution',
				'publishing-series': 'Publishing series',
				'series': 'Series',
				'content': 'Material in book',
				'book': 'Book',
				'place': 'Locality',
				'creative-work': 'Work',
				'event': 'Event',
				'movie': 'Movie',
				'authors-book': 'Book',
				'spectacle': 'Performance',
				'radio': 'Radio',
				'television': 'Television',
				'rtv': 'Radio and television',
				'anthologyDesc': 'Description',
				'anthTypes': 'Type of work in anthology',
				'anthAuthors': 'Author',
				'anthTranslators': 'Translator',
				'mailAddressee': 'Addressee',
				'mailSender': 'Sender',
				'mailDescription': 'Description of and relation between pages',
				'interInterviewer': 'Interviewer',
				'interInterlocutor': 'Interviewee',
			},
			item_types: {
				'creative-work': 'Works',
				'records': 'Records',
				'content': 'Materials in book',
				'event': 'Events',
				'journal': 'Periodicals',
				'journal-item': 'Materials in periodicals',
				'publishing-series': 'Publishing series',
				'event-series': 'Event series',
				'institution': 'Institutions',
				'series': 'Series',
				'place': 'Localities',
			},
			types: {
				'person': 'Personal page',
				'publishing_series': 'Publishing series page',
				'institution': 'Institution page',
				'journal': 'Periodical page',
				'journal-year': 'Year',
				'journal-number': 'Periodical issue page',
				'work': 'Work page',
				'event': 'Event page',
				'event-series': 'Event series page',
				'series': 'Series page',
				'book': 'Book',
				'content': 'Content in book',
				'creative-work': 'Work page',
				'movie': 'Movie',
				'spectacle': 'Theater performance',
				'publishing-series': 'Publishing series',
				'journal-item': 'Material in periodical',
				'radio': 'Radio program',
				'television': 'Television program',
				'authors-book': 'Book by one author',
				'authors_book': 'Book by one author',
				'collective-book': 'Book by more than one author',
				'anthology': 'Anthology',
				'letters': 'Letters and correspondence',
				'authors-book-content': 'Content of a book by one author',
				'collective-book-content': 'Content of a book by more than one author',
				'anthology-content': 'Content of anthology',
				'letters-content': 'Content of letters and correspondence',
				'resumptionsBroadcasts': 'Broadcast dates',
				'resumptionsProgram': 'Broadcast program',
				type: {
					'person': 'person',
					'publishing_series': 'publishing series',
					'institution': 'institution',
					'journal': 'periodical',
					'journal-year': 'year',
					'journal-number': 'periodical issue',
					'work': 'work',
					'event': 'event',
					'event-series': 'event series',
					'series': 'series',
					'book': 'book',
					'content': 'content in book',
					'creative-work': 'work page',
					'movie': 'movie',
					'spectacle': 'theater performance',
					'publishing-series': 'publishing series',
					'journal-item': 'material in periodical',
					'radio': 'radio program',
					'television': 'television program',
					'authors-book': 'book by one author',
					'authors_book': 'book by one author',
					'collective-book': 'book by more than one author',
					'anthology': 'anthology',
					'letters': 'letters and correspondence',
				}
			},
			cards: {
				'person_card': 'Personal page',
				'institution_card': 'Institution page',
				'event_cycle_card': 'Event series page',
				'event_card': 'Event page',
				'work_card': 'Work page',
				'journal_card': 'Periodical page',
				'journal-number_card': 'Periodical issue page',
				'publishing-series_card': 'Publishing series page',
				'event-series_card': 'Event series page',
				'card_id': 'ID',
				'yearbooks': "Year's issues",
				'yearbooks_number': 'Total number of records',
				'yearbooks_warning': 'Comment',
				'yearbooks_cause': 'Reason',
				'yearbooks_info': 'This periodical is no longer edited.',
				'show_yearbook_details': 'Show issue details',
				'dedication': 'Dedication',
				'description': 'Comment',
				'as_book': 'as book',
				'is_developed': 'Important: this issue is featured in our database',
			},
			authors_book: {
				'bibliographic_text': 'Bibliographical description',
				'record_details': 'Record details',
				'edition_year': 'Publication year',
				'location': 'Publication place',
				'phisical_description': 'Physical description'
			},
			person: {
				'valid_name': 'Proper surname and first name',
				'alias': 'Alias',
				'family_name': 'Family name',
				'monastic_name': 'Religious name',
				'other_name': 'Other name form',
				'other_surname': 'Other surname form',
				'collective_alias': 'Group alias',
				'authors_company': 'Author partnership',
				'codename': 'Codename',
				'pbl_field': 'PBL domain and subject heading',
				'annotation': 'Annotation',
				'birth_date': 'Date of birth',
				'birth_location': 'Place of birth',
				'death_date': 'Date of death',
				'death_location': 'Place of death',
				'sex': 'Sex'
			},
			institution: {
				'activity_time': 'Period of operation under this name',
				'activity_location': 'Operation place',
				'other_names': "Other forms of the institution's name",
				'types': 'Institution type',
				'relations': 'Relations with other institutions',
				'pbl_field': 'PBL domain and subject heading',
				'annotation': 'Annotations',
			},
			journal: {
				'other_titles': 'Other title forms',
				'addition': 'Supplement to',
				'includes': 'Contains',
				'previous_title': 'Previous title',
				'continuation': 'Continuation',
				'nature': 'Periodical character',
				'frequency': 'Publication frequency',
				'executive_body': 'Causative institution',
				'publisher': 'Publisher',
				'place_of_publication': 'Publication place',
				'publishingPeriod': 'Publication period',
				'series': 'Series',
				'issn': 'ISSN',
				'pbl_field': 'PBL domain and subject heading',
				'annotation': 'Annotation',
				'journal_volume': 'Edited year',
			},
			journal_number: {
				'unit_title': 'Individual title',
				'dedication': 'Dedication',
				'addition': 'Supplement to',
				'nature': 'Periodical character',
				'executive_body': 'Causatory institution',
				'publisher': 'Publisher',
				'place_of_publication': 'Publication place',
				'series': 'Series',
				'issn': 'ISSN',
				'physical_deficiency': 'Physical deficiencies',
				'pbl_field': 'PBL domain and subject heading',
				'annotation': 'Annotations',
			},
			work: {
				'author': 'Author',
				'title': 'Title',
				'base_title': 'Translation base title',
				'base_language': 'Translation base language',
				'original_title': 'Original title',
				'original_language': 'Original language',
				'incipit': 'Incipit',
				'pbl_field': 'PBL domain and subject heading',
				'annotation': 'Annotations',
			},
			publishing_series: {
				'title': 'Title',
				'base_title': 'Translation base title',
				'base_language': 'Translation base language',
				'original_title': 'Original title',
				'original_language': 'Original language',
				'subtitle': 'Series subtitle',
				'base_subtitle': 'Translation base subtitle',
				'base_language_subtitle': 'Translation base language',
				'original_subtitle': 'Original subtitle',
				'original_language_subtitle': 'Original language',
				'editor': 'Series editor',
				'publisher': 'Publishing house',
				'annotation': 'Annotations',
			},
			event_series: {
				'activity_time': 'Period when the series used this name',
				'other_names': "Other forms of the event series' name",
				'type': 'REvent series type',
				'organizer': 'Organizer',
				'relations': 'Relations to other event series',
				'concerns': 'Concerns',
				'pbl_field': 'PBL domain and subject heading',
				'annotation': 'Annotations',
			},
			series: {
				'type': 'Series type',
				'author': 'Author',
				'title': 'Title',
				'base_title': 'Translation base title',
				'base_language': 'Translation base language',
				'original_title': 'Original title',
				'original_language': 'Original language',
				'dedication': 'Dedication',
				'incipit': 'Incipit',
				'pbl_field': 'PBL domain and subject heading',
				'correspondence_sides': 'Correspondence pages',
				'interview_sides': 'Interview pages',
				'annotation': 'Annotations',
				'source': 'Source'
			},
			event: {
				'other_name': 'Other forms of the event name',
				'type': 'Event type',
				'edition': 'Edition',
				'place': 'Event place',
				'date': 'Event date',
				'organizer': 'Event organizer',
				'winners': 'Laureates',
				'series': 'Event series',
				'relations': 'Relations to other events',
				'concerns': 'Concerns',
				'pbl_field': 'PBL domain and subject heading',
				'annotation': 'Annotations',
			},
		},
		results: {
			'other_result': 'The phrase searched has also been found in the PBL domain name',
			'no_results': 'No results.',
			'wrong_query': 'Wrong query.',
			'tab_content_error': 'Error loading filters.',
			'back_to': 'Back to search results',
			'chosen_filters': 'Selected filters',
			'remember_filters': 'Block filters',
			'info': 'Check this to apply the currently selected filters to the next query.',
			'delete_value': 'Delete the value',
			'clear_filters': 'Clear filters',
			'get_all_filters': 'Get all filters',
			'date_from': 'Date from',
			'date_to': 'Date to',
			'date_placeholder': 'DD.MM.YYYY',
			'year_placeholder': 'YYYY',
			'no_filters': 'Query does not match search criteria.',
			'related_record': 'Related materials',
			'field_section': 'Record domain and subject heading',
			'field': 'Domain',
			'headings': 'Main subject heading',
			'headings_secondary': 'Secondary subject heading',
			'secondaryHeadings': 'Secondary subject heading',
			'show_fields': 'See domains and subjects headings',
			'choose_filters': 'Select filters',
			'filters': 'Filters',
			'choose_sorting': 'Select sorting mode',
			'search_for': 'Enter the first letter or phrase',
			'submit': 'Submit',
			'close': 'Close',
			'bc': 'BC',
			'csv': 'Download the CSV file',
			'api': 'Download the API file',
			'no_results_title': 'No results matching the query.',
			'no_results_title_headings': 'Currently, in the PBL database we have not recorded materials matching the selected group.',
			'no_results_desc': '<li>Check the spelling of the phrase searched. </li><li>Enter a query with a similar meaning or enter a more general one. </li><li>Try to limit the number of words in the phrase searched. </li>',
			'no_results_suggestions': 'Suggestions:',
			'no_results_other_desc': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
			'contact': 'mailto:pracownia@pbl.ibl.poznan.pl',
		},
		filter_labels: {
			'HEADING': 'PBL domain and subject heading',
			'HEADINGS': 'PBL domain and subject heading',
			'ORIGIN_SOURCE': 'Information provenance',
			'CROSS_HEADING': 'Cross-section subject heading',
			'FORM': 'Form',
			'RECORD_FORM': 'Form',
			'SERIES_FORM': 'Form',
			'RECORD_TYPE': 'Record type',
			'FILE_TYPE': 'File type',
			'EVENT_TYPE': 'Event type',
			'INSTITUTION_TYPE': 'Institution type',
			'SERIES_TYPE': 'Series type',
			'SERIES_PERSONS_FUNCTION': 'Person and their functions',
			'YEAR': 'Year',
			'JOURNAL_YEAR': "Year's issue",
			'LANGUAGE': 'Publication language',
			'PERSON': 'Person and their function',
			'RECORD_PERSON': 'Person and their functions',
			'SERIES_PERSON': 'Person and their functions',
			'PERSONS_FUNCTION': "Person's function",
			'SERIES_RECORDS_FUNCTION': "Person's function",
			'RECORD_PERSONS_FUNCTION': "Person's function",
			'RECORD_LOCATION': 'Place',
			'BORN_LOCATION': 'Place of birth',
			'DEATH_LOCATION': 'Place of death',
			'JOURNAL_LOCATION': 'Publication place',
			'EVENT_LOCATION': 'Event place',
			'INSTITUTION_LOCATION': 'Operation place',
			'SOURCE': 'Source',
			'RECORD_SOURCE': 'Source',
			'SERIES_SOURCE': 'Source',
			'COLLECTION': 'Collection',
			'BORN_YEAR': 'Year of birth',
			'DEATH_YEAR': 'Year of death',
			'SEX': 'Sex',
			'AUTHOR': 'Author',
			'JOURNAL_CHARACTER': "Periodical's character",
			'FREQUENCY': 'Publication frequency',
			'EVENT_DATE': 'Event data',
			'EVENT_PERIOD': 'For the period',
			'SERIES': 'Series',
			'ORGANIZER': 'Organizer',
			'LAUREATE': 'Laureates',
			'INSTITUTION_PERIOD': 'Operation period',
			'NUMBER': 'Number',
		},
		date_range: {
			'required': 'BC date cannot be empty.',
			'required_bc': 'BC date cannot be empty.',
			'format': 'Wrong date format.',
			'out_of_range': 'Date is later than today.',
			'to_exceeds_from': 'Date is later than the date to',
		},
		pagination: {
			'from': 'from',
			'previous': 'Previous',
			'previous_title': 'Previous page',
			'next': 'Next',
			'next_title': 'Next page',
			'input': 'Enter the page number',
		},
		ipp: {
			'results_number': 'number of results on page'
		},
		sort: {
			'accuracy': 'Sort by accuracy',
			'author_asc': 'Sort by author in ascending alphabetical order',
			'author_desc': 'Sort by author in descending alphabetical order',
			'name_asc': 'Sort by name in ascending alphabetical order',
			'name_desc': 'Sort by name in descending alphabetical order',
			'title_asc': 'Sort by title in ascending alphabetical order',
			'title_desc': 'Sort by title in descending alphabetical order',
			'date_asc': 'Sort by date (from the earliest)',
			'date_desc': 'Sort by date (from the latest)',
			'source_title_asc': 'Sort alphabetically by author',
		},
		login_page: {
			'title': 'Login',
			'username': 'Username',
			'password': 'Password',
			'login': 'Log in',
			'username_required': 'Username is required',
			'password_required': 'Password is required',
		},
		alt: {
			'chevron_up': 'Chevron up',
			'chevron_down': 'Chevron down',
			'chevron_right': 'Chevron right',
			'chevron_left': 'Chevron left',
			'double_chevron_left': 'Double chevron left',
			'arrow_circle_full': 'Arrow right inside full circle',
			'arrow_circle_empty': 'Arrow right inside empty circle',
			'plus': 'Plus icon',
			'bin': 'Bin icon',
			'warning': 'Warning icon',
			'mail': 'Mail icon',
			'structure': 'Structure icon',
			'search': 'Magnifier icon',
			'folder': 'Picture referring to the folder',
			'collection': 'Image referring to the collection',
			'cookies': 'Cookie icon',
			'partners': 'Partner logo',
			'menu': 'Hamburger menu icon',
			'home': 'Home icon',
			'card': 'File icon',
			'csv': 'CSV icon',
			'api': 'API icon',
			'book': 'Book icon',
			'content': 'Content icon',
			'journal': 'Journal icon',
			'journal_number': 'Journal number icon',
			'journal_item': 'Journal item icon',
			'event_series': 'Event series icon',
			'institution': 'Institution icon',
			'person': 'Person icon',
			'series': 'Series icon',
			'spectacle': 'Spectacle icon',
			'movie': 'Movie icon',
			'creative_work': 'Creative work icon',
			'event': 'Event icon',
			'tv': 'Television icon',
			'radio': 'Radio icon',
			'link': 'External link icon',
			'author_company': 'Author partnership icon',
			'record': 'Record icon',
			'record_type': 'Record type icon',
			'video_dots': 'Dots image',
			'video_poster': 'Poster presenting Krzysztof Kamil Baczyński on the background of the city with the inscription Polska Bibliografia Literacka Collection of the Texts',
			'info': 'Info icon',
			'no_results': 'Image with scattered paperclips',
			'results_icon': 'Icon with record type',
			'logo': 'PBL Logo',
			'loader': 'Ikona ładowania logowania',
			'externalLinks': 'External link'
		},
		dropdown: {
			'download_format_label': 'Download the bibliographic description',
			"download_format_item": "Download",
		},
		title: {
			'csv': 'Download CSV file',
			'api': 'Go to API page',
			'home': 'Go to homepage',
			'up': 'Return to the top of the page',
			'contact': 'Contact the editor of the department',
			'error': 'Contact the editor of the department to report an error',
			'facebook': 'Visit and like the PBL profile on Facebook - open in a new window',
			'possibilities_btn': 'PBL in the OPEN repository - open the page in a new window',
			'carousel_prev': 'Show previous elements of the bar',
			'carousel_next': 'Show next elements of the bar',
			'queries_examples': 'Go to the page with an example',
			'pl_title': 'Polska wersja językowa',
			'en_title': 'English language version',
			'search_bar': 'Search',
			"pagination_btn": "Pagination button"
		},
		aria: {
			'search_bar': "Searching phrase",
		},
		font: {
			'normal': 'normal',
			'medium': 'medium',
			'big': 'big',
		},
		loading_gif: 'Loading',
		loading_text: 'Page loading. It can take a few minutes.',
		loading_error: 'Error. Sorry for the inconvenience.',
		show_more: 'Show more',
		show_all: 'Show all',
		back: 'Back',
		close: 'Close',
		submit: 'Submit',
		cancel: 'Cancel',
		select_all: 'Select all',
		clean_all: 'Remove selection',

		clean: 'Clear',
		search_for: 'Search',
		look_for: 'Look for',
		pl: 'Polish',
		en: 'English',
		font: 'Font size',
		font_default: 'Default font',
		font_medium: 'Medium font',
		font_big: 'Large font',
		font_default_text: 'Default font enabled',
		font_medium_text: 'Medium font enabled',
		font_big_text: 'Large font enabled',
		contrast: 'Contrast',
		contrast_default: 'Default contrast',
		contrast_black_yellow: 'Black-and-yellow contrast',
		contrast_default_text: 'Default contrast enabled',
		contrast_black_yellow_text: 'Black-yellow contrast enabled',
		home: 'Homepage',
		login: 'Log in',
		logout: 'Logout',
		login_hello: 'Hello ',
		read_more: 'Read more',
		cookies_desc: 'We utilize cookies in order to optimize the website. If do not want cookies to be saved on your disc change your browser settings. See the information about cookies and privacy policy.',
		welcome_desc: 'Welcome to the website of "Polish Literary Bibliography", created as part of the grant of the National Program for the Development of Humanities (No. 0061 / NPRH3 / H11 / 82/2014). The website is still being developed - we encourage you to test it and submit comments. During the transitional period, full bibliographic data is available at <a href="www.pbl.ibl.poznan.pl"> www.pbl.ibl.poznan.pl </a>.',
		welcome_go: 'Go to page',
		cookies_header: 'This page uses cookies.',
		accept: 'I understand.',
	},
	pl: {
		headers: {
			'main': 'Strona główna',
			'advanced_search_results': 'Wyniki wyszukiwania zaawansowanego',
			'card': 'Karta',
			'full_results': 'Wyniki wyszukiwania',
			'advanced_search': 'Wyszukiwanie zaawansowane',
			'record': 'Zapis',
			'files': {
				'person': 'Kartoteka osób',
				'creative-work': 'Kartoteka utworów',
				'journal': 'Kartoteka czasopism',
				'event': 'Kartoteka wydarzeń',
				'institution': 'Kartoteka instytucji',
				'series': 'Kartoteka cykli',
			}
		},
		alerts: {
			'success': 'Użytkownik został zalogowany',
			'error': 'Wystąpił błąd logowania',
			'error_auth': 'Zły login lub hasło',
			'logout_success': 'Użytkownik został wylogowany',
		},
		titles: {
			'pbl': 'PBL',
			'main': 'Strona główna',
			'results': 'Wyniki wyszukiwania',
			'advanced-results': 'Wyniki wyszukiwania zaawansowanego',
			'results_for': 'dla zapytania',
			'headings': 'Dziedziny i działy PBL',
			'headings-about': 'Charakterystyka dziedzin i działów PBL',
			'headings-search': 'Charakterystyka dziedzin i działów PBL',
			'records': 'Zapisy',
			'records-about': 'Charakterystyka zapisów PBL',
			'files': 'Kartoteki',
			'files-about': 'Charakterystyka kartotek PBL',
			'files-person': 'Kartoteka osób',
			'files-institution': 'Kartoteka instytucji',
			'files-event': 'Kartoteka wydarzeń',
			'files-creative-work': 'Kartoteka utworów',
			'files-series': 'Kartoteka cykli',
			'files-journal': 'Kartoteka czasopism',
			'item-book': 'Książki',
			'item-journal-item': 'Materiał w czasopiśmie',
			'item-movie': 'Film',
			'item-spectacle': 'Spektakl teatralny',
			'item-radio': 'Audycje radiowe',
			'item-television': 'Programy telewizyjne',
			'item-content': 'Materiał w książce',
			'item-person': 'Kartoteka osób',
			'item-institution': 'Kartoteka instytucji',
			'item-event': 'Kartoteka wydarzeń',
			'item-event-series': 'Kartoteka wydarzeń',
			'item-series': 'Kartoteka cykli',
			'item-journal': 'Kartoteka czasopism',
			'item-journal-number': 'Kartoteka czasopism',
			'item-creative-work': 'Kartoteka utworów',
			'person': 'Kartoteki',
			'institution': 'Kartoteki',
			'event': 'Kartoteki',
			'series': 'Kartoteki',
			'journal': 'Kartoteki',
			'about': 'O PBL',
			'about-what-is': 'Czym jest PBL',
			'about-how-search': 'Jak wyszukiwać i czytać wyniki?',
			'about-what-in': 'Co znajdziesz w PBL?',
			'about-examples': 'Przykłady kwerend',
			'about-how-create': 'Jak tworzymy PBL?',
			'about-source': 'Źródła PBL',
			'about-conditions': 'Warunki dostępu do danych',
			'about-team': 'Zespół',
			'about-contact': 'Kontakt',
			'about-privacy-policy': 'Polityka prywatności',
            'about-accessibility' : 'Deklaracja dostępności',
			'news': 'Aktualności',
			'news-all': 'Wszystkie aktualności',
			'news-events': 'Wydarzenia',
			'news-conferences': 'Konferencje',
			'news-publications': 'Publikacje',
			'news-from-life': ' Z życia PBB',
			'news-projects': 'Projekty',
			'advanced-search': 'Wyszukiwanie zaawansowane',
			'collections': 'Charakterystyka kolekcji PBL',
			'login': 'Logowanie'
		},
		breadcrumbs: {
			'home': 'Strona główna',
			'records': 'Zapisy',
			'cards': 'Kartoteki',
			'files': 'Kartoteki',
			'book': 'Książki',
			'news': 'Aktualności',
			'content': 'Materiały w książkach',
			'movie': 'Filmy',
			'radio': 'Audycje radiowe',
			'spectacle': 'Spektakle teatralne',
			'journal-item': 'Materiały w czasopismach',
			'television': 'Programy telewizyjne',
			'headings': 'Dziedziny i działy PBL',
			'headings_about': 'Charakterystyka dziedzin i działów PBL',
			'headings_results': 'Szukaj w nazwie działu',
			'about-pbl': 'O PBL',
			'journal-number': 'Kartoteka czasopism',
			'journal': 'Kartoteka czasopism',
			'series': 'Kartoteka cykli',
			'event': 'Kartoteka wydarzeń',
			'person': 'Kartoteka osób',
			'creative-work': 'Kartoteka utworów',
			'institution': 'Kartoteka instytucji',
			'event-series': 'Kartoteka wydarzeń',
			'all': 'Wszystkie aktualności',
			'events': 'Wydarzenia',
			'conferences': 'Konferencje',
			'publications': 'Publikacje',
			'from-life': 'Z życia PBB',
			'projects': 'Projekty',
			'collections': 'Kolekcje',
			'collections-about': 'Charakterystyka kolekcji PBL',
			'movie-theatre-rtv': 'Teatr, film, radio i telewizja',
			'literature-theory': 'Teoria literatury',
			'polish-literature': 'Literatura polska',
			'foreign-literature': 'Literatury obce',
		},
		validation: {
			'required': 'Pole wymagane',
			'no_fields': 'Przynajmniej jedno zapytanie jest wymagane'
		},
		errors: {
			'error_404': 'Niestety strona, którą chcesz odwiedzić, nie istnieje.',
			'error_404_desc': '<li>Błąd w adresie - sprawdź jego poprawność, </li><li>Strona nie istnieje (nie istniała lub została usunięta), </li><li>Strona zmieniła swoją nazwę lub lokalizację.</li>',
			'error_500': 'Wewnętrzny błąd serwera',
			'error_500_desc': 'Chwilowo nie możemy pokazać tej strony ze względu na wewnętrzny błąd serwera. </br> Odśwież stronę lub spróbuj za kilka minut. Jeśli błąd będzie nadal występował, prosimy o <a href="/about/contact">kontakt</a>.',
			'error_code': 'Kod błędu: ',
			'error_causes': 'Możliwe przyczyny: ',
			'sorry': 'Przepraszamy za niedogodności.',
			'what_now': 'Co teraz?',
			'go_to_homepage': 'Przejdź do strony głównej',
			'use_map': 'Skorzystaj z mapy poniżej',
			'error_info': 'Informacja: ',
		},
		header: {
			'contact': 'Kontakt'
		},
		footer: {
			'credits': 'Oprogramowanie',
			'pcss': 'Poznańskiej Centrum Superkomputerowo-Sieciowe',
			'visit': 'Odwiedź nas',
			'admin': 'Panel administracyjny',
			'login': 'Logowanie',
			'fb': 'Facebook',
			'sitemap': 'Mapa strony'
		},
		about_pbl: {
			'what-in': 'Co znajdziesz w PBL?',
			'what-is': 'Czym jest PBL?',
			'how-search': 'Jak wyszukiwać i czytać wyniki?',
			'examples': 'Przykłady kwerend',
			'examples_desc': 'Przykładowe opisy kwerend w bazie PBL wykonanych z wykorzystaniem podstawowego okna wyszukiwania i faset, opcji wyszukiwania zaawansowanego lub przeglądania zawartości bazy przez widoki dziedzin i działów, kartoteki lub zapisy. W każdej kwerendzie wskazujemy jeden problem badawczy lub jedno zapytanie wyszukiwawcze i wyjaśniamy, w jaki sposób otrzymać satysfakcjonujące wyniki.',
			'how-create': 'Jak tworzymy PBL?',
			'source': 'Źródła PBL',
			'conditions': 'Warunki dostępu do danych',
			'team': 'Zespół',
			'contact': 'Kontakt',
			'privacy-policy': 'Polityka prywatności',
			'query_results': 'Zobacz wyniki dla tej kwerendy',
			'api-docs': 'Dokumentacja API',
            'accessibility' : 'Deklaracja dostępności'
		},
		news: {
			'all': 'Wszystkie aktualności',
			'news': 'Aktualności',
			'events': 'Wydarzenia',
			'conferences': 'Konferencje',
			'publications': 'Publikacje',
			'from-life': 'Z życia PBB',
			'projects': 'Projekty',
			'search': 'Szukaj w Aktualnościach',
			'categories': 'Kategorie',
			'no_results_title': 'Nie znaleźliśmy wyników odpowiadających Twojemu zapytaniu.',
			'no_results_suggestions': 'Niestety, nie udało się znaleźć w serwisie nic, co pasowałoby do hasła, którego szukasz. Spróbuj poszukać za pomocą innych haseł lub zwrotów.',
			'no_results_all_news': 'Przejdź do wszystkich aktualności',
			'no_results_change_query': 'Zmien zapytanie',

		},
		news_desc: {
			'all': 'Aktualności związane z działalnością Pracowni Bibliografii Bieżącej IBL PAN w Poznaniu i rozwojem „Polskiej Bibliografii Literackiej”.',
			'events': 'Informacje o wydarzeniach - warsztatach, spotkaniach otwartych, wykładach - organizowanych przez zespół Pracowni Bibliografii Bieżącej, a także o udziale jego członków i członkiń w przedsięwzięciach popularyzatorskich lub edukacyjnych.',
			'conferences': 'Aktualności o konferencjach związanych z działalnością Pracowni Bibliografii Bieżącej oraz problematyką pokrewną.',
			'publications': 'Informacje o publikacjach dotyczących „Polskiej Bibliografii Literackiej” oraz najciekawszych wynikach badań  z zakresu informacji naukowej i bibliotekoznawstwa.',
			'from-life': 'Informacje na temat funkcjonowania Pracowni Bibliografii Bieżącej – ciekawostki z życia Pracowni, zmiany kadrowe, aktualne oferty pracy.',
			'projects': 'Informacje o projektach naukowych realizowanych w Pracowni Bibliografii Bieżącej.',
			'search': 'Szukaj w Aktualnościach',
		},
		search: {
			'how': 'Jak wyszukiwać i czytać wyniki?',
			'about': 'Dotyczące',
			'info': 'Wyszukiwana fraza',
			'count': 'Liczba wyników',
			'area': 'Obszar',
			'advanced': 'Wyszukiwanie zaawansowane',
			'what': 'Wpisz słowo lub frazę, której szukasz',
			'where': 'Gdzie szukasz?',
			options: {
				'all': 'Cała zawartość PBL',
				'records': 'Zapisy',
				'person': 'Osoby',
				'creative-work': 'Utwory',
				'journal': 'Czasopisma',
				'event': 'Wydarzenia',
				'institution': 'Instytucje',
				'series': 'Cykle',
				'publishing-series': 'Serie wydawnicze',
				'event-series': 'Cykle wydarzeń',
			},
			options_single: {
				'all': 'Cała zawartość PBL',
				'records': 'Zapis',
				'person': 'Osoba',
				'creative-work': 'Utwór',
				'journal': 'Czasopismo',
				'event': 'Wydarzenie',
				'institution': 'Instytucja',
				'series': 'Cykl',
				'publishing-series': 'Serie wydawnicze',
				'event-series': 'Cykle wydarzeń',
			},
		},
		main_page: {
			'about': 'Dane o <strong>kulturze literackiej</strong>, <strong>teatralnej</strong>  i <strong>filmowej</strong> za lata <strong>1989-2023</strong>',
			'browse_headings': 'Przeglądaj dziedziny',
			'records_headings': 'Zapisów w dziedzinie',
			'literature-theory': 'Teoria literatury',
			'polish-literature': 'Literatura polska',
			'foreign-literature': 'Literatury obce',
			'movie-theatre-rtv': 'Teatr, film, radio i telewizja',
			'news': 'Aktualności',
			'news_all': 'Wszystkie aktualności',
			'72': 'From life of PBB',
			'60': 'Events',
			'76': 'Conferences',
			'74': 'Publications',
			'81': 'Projects',
			'68': 'Z życia PBB',
			'35': 'Wydarzenia',
			'66': 'Konferencje',
			'70': 'Publikacje',
			'79': 'Projekty',
			'more_pbl': 'Więcej o PBL',
			'possibilities_btn': 'PBL w repozytorium OPEN',
			'menu': 'Menu',
			'numbers': 'PBL <strong>w liczbach</strong>',
			'what_in': '<strong>Co znajdziesz</strong> w PBL?',
			'more_queries_examples': 'Więcej przykładów kwerend',
			'types': {
				'author': 'Twórców',
				'creative-work': 'Utworów',
				'book': 'Książek',
				'review': 'Recenzji',
				'movie': 'Filmów',
				'event': 'Wydarzeń',
				'spectacle': 'Spektakli teatralnych',
				'rtv': 'Słuchowisk'
			}
		},
		advanced_search: {
			tabs: {
				'all': 'Cała zawartość PBL',
				'records': 'Zapisy',
				'person': 'Osoby',
				'creative-work': 'Utwory',
				'journal': 'Czasopisma',
				'event': 'Wydarzenia',
				'institution': 'Instytucje',
				'event-series': 'Cykle wydarzeń',
				'publishing-series': 'Serie wydawnicze',
				'series': 'Serie',
			},
			search_field_options: {
				'TITLE': 'Tytuł',
				'KIND': 'Forma i typ',
				'TYPE': 'Typ publikacji',
				'WORK': 'Utwór',
				'DATE': 'Data publikacji',
				'SERIES': 'Seria',
				'PBLISHING_SERIES': 'Seria wydawnicza',
				'COLLECTION': 'Kolekcja',
				'TEXT': 'Tekst',
				'PERSON': 'Osoba',
				'SEX': 'Płeć',
				'DEATH_DATE': 'Data śmierci',
				'TEXT_IN_ANNOTATION': 'Wyrażenie w polu opisowym',
				'ROLE': 'Rola',
				'SEARCH_FORM': 'Forma serii',
				'PERSON_NAME': 'Nazewnictwo osoby',
				'HEADING': 'Dziedzina i dział PBL',
				'DATE_OF_BIRTH': 'Data urodzenia',
				'PLACE_OF_BIRTH': 'Miejsce urodzenia',
				'DATE_OF_DEATH': 'Data śmierci',
				'PLACE_OF_DEATH': 'Miejsce śmierci',
				'ORIGIN': 'Proweniencja informacji',
				'ANNOTATIONS': 'Adnotacje',
				'REMARKS': 'Uwagi własne',
				'INNER_TAG': 'Tagi wewnętrzne',
				'LINKED_INSTITUTION': 'Powiązane instytucje',
				'LINKED_JOURNAL_SOURCE': 'Powiązane źródła czasopism',
				'EVENT_NAME': 'Nazwa',
				'AUTHORS': 'Autorzy/rki',
				'SENDERS': 'Nadawcy/czynie',
				'INTERLOCUTORS': 'Rozmówcy/czynie',
				'ADRESSES': 'Adresaci/tki',
				'SOURCES': 'Źródła',
				'EVENT_TYPE': 'Typ',
				'EDITION_NUMBER': 'Numer wydania',
				'FOR_PERIOD': 'Za okres',
				'EVENT_PLACE': 'Miejsce',
				'BELONGING_TO_EVENT_SERIES': 'Przynależność do cyklu wydarzeń',
				'EVENT_ORGANIZER': 'Organizator',
				'LINKED_PLACE': 'Powiązane miejsce',
				'EVENT_SERIES_NAME': 'Nazwa cyklu wydarzeń',
				'EVENT_DATE': 'Data',
				'INSTITUTION_TYPE': 'Typ',
				'PRINCIPAL_TITLE': 'Tytuł',
				'PERIOD_OF_ACTIVITY': 'Okres aktywności',
				'PLACE_OF_ACTIVITY': 'Miejsce aktywności',
				'ADDRESSEE': 'Adresat/ka',
				'PHYSICAL_DESCRIPTION': 'Opis fizyczny',
				'CO_CREATION_TYPE': 'Typ współtwórstwa',
				'LINKED_SERIES': 'Powiązane cykle',
				'PREMIERE_THEATER': 'Premiery teatralne',
				'LINKED_EVENT': 'Powiązane wydarzenia',
				'LANGUAGE': 'Język',
				'LAUREATE': 'Laureat/ka',
				'RECORD_FORM': 'Forma',
				'RECORD_TYPE': 'Typ',
				'RECORD_PLACE': 'Miejsce',
				'CO_CREATOR': 'Osoba współtworząca',
				'RECORD_YEAR': 'Rok',
				'FILM_STUDIO': 'Studio filmowe',
				'TRIGGER_INSTITUTION': 'Instytucja sprawcza',
				'BELONGING_TO_SERIES': 'Przynależność do cyklu',
				'RECORD_SOURCE': 'Źródło',
				'LINKED_RECORD': 'Powiązany zapis',
				'LINKED_CREATIVE_WORK': 'Powiązany utwór',
				'LINKED_PUBLISHING_SERIES': 'Powiązana seria wydawnicza',
				'SENDER': 'Nadawca/czyni',
				'INTERVIEWER': 'Osoba przeprowadzająca wywiad',
				'INTERLOCUTOR': 'Rozmówca/czyni',
				'CHAPTER_TITLE': 'Tytuł rozdziału',
				'ANTHOLOGY_DESCRIPTION': 'Opis antrologii',
				'BOOK_EDITION': 'Wydanie ksiązki',
				'EXTERNAL_LINK': 'Linki zewnętrzne',
				'AUTHOR': 'Autor/ka',
				'CREATOR': 'Redaktor',
				'ABBREVIATION': 'Skrót',
				'PUBLISHED_IN_SERIES': 'Przynależność do serii',
				'PUBLISHED_FROM': 'Wydawane od',
				'PUBLISHED_TO': 'Wydawane do',
				'PUBLISHING_PLACE': 'Miejsce wydania',
				'ISSN': 'ISSN',
				'LIBRARY': 'Biblioteka',
				'SIGNATURE': 'Sygnatura',
				'contains': 'zawiera',
				'not_contains': 'nie zawiera',
				'contains_anything': 'zawiera cokolwiek',
				'is_empty': 'jest puste',
				'CONTAINS': 'zawiera',
				'NOT_CONTAINS': 'nie zawiera',
				'CONTAINS_ANYTHING': 'zawiera cokolwiek',
				'IS_EMPTY': 'jest puste',
				'IN_RANGE': 'jest w przedziale',
				'in_range': 'jest w przedziale',
				'YEAR_FROM': 'Rok od',
				'YEAR_TO': 'Rok do',
				'ITEM_FROM': 'Materiał od',
				'ITEM_TO': 'Materiał do',
				'CHARACTER': 'Charakter',
				'RELATION': 'Związek z',
				'NAME': 'Nazwa',
				'DATE_FROM': 'Data od',
				'DATE_TO': 'Data do',
				'EDITION_OF': 'Edycja',
				'LOCATION': 'Lokalizacja',
				'and': 'i',
				'or': 'lub',
				'AND': 'i',
				'OR': 'lub',
			},
			'relation': 'Związek',
			'query': 'Wartość',
			'date_from': 'Data od',
			'date_to': 'Data do',
			'dates_from': 'od',
			'dates_to': 'do',
			'add_fields': 'Dodaj kolejne kryterium wyszukiwania',
			'add_field': 'Dodaj kolejną wartość',
			'remove_field': 'Usuń wartość',
			'remove_fields': 'Usuń kryterium wyszukiwania',
			'phraze': 'Wpisz słowo lub frazę',
			'select_phraze': 'Wybierz frazę',
			'search_field': 'Atrybut',
			'how': 'Jak wyszukiwać i czytać wyniki?',
			'key': 'Przedmiot Twojego wyszukiwania',
			'select_attribute': 'Wybierz atrybut...',
			'and': 'i',
		},
		advanced_search_results: {
			'change_query': 'Zmień zapytanie',
			'results_number': 'Liczba wyników',
		},
		field_types: {
			'polish-literature': 'Literatura polska',
			'literature-theory': 'Teoria literatury',
			'foreign-literature': 'Literatury obce',
			'movie-theatre-rtv': 'Teatr, film, radio, telewizja'
		},
		characteristics: {
			'records': 'Charakterystyka zapisów PBL',
			'files': 'Charakterystyka kartotek PBL',
			'headings': 'Charakterystyka dziedzin i działów PBL',
			'headings_structure': '<strong>Struktura</strong> dziedzin i działów PBL',
			'headings_results': 'Szukaj w nazwie działu',
			'heading': 'Dziedzina',
			'heading_structure': 'Struktura dziedziny',
			'literature-theory': 'Teoria literatury',
			'polish-literature': 'Literatura polska',
			'foreign-literature': 'Literatury obce',
			'movie-theatre-rtv': 'Teatr, film, radio i telewizja',
			'show_structure': 'Pokaż strukturę',
			'hide_structure': 'Zwiń strukturę',
			'show_description': 'Pokaż opis',
			'hide_description': 'Zwiń opis',
			'go_to_file': 'Przejdź do kartoteki',
			'go_to_record': 'Zobacz zapisy',
			'all_records': 'Zobacz wszystkie zapisy',
			'field_desc': 'Opis działu',
			'contact': 'Kontakt',
			'error': 'Wystąpił błąd. Zawartość nie może zostać wyświetlona.',
			'search': 'wpisz słowo lub frazę',
			'search_in': 'Szukaj w nazwie działu',
			'search_results_title': '<strong>Wyniki wyszukiwania w strukturze</strong> dziedzin i działów PBL',
			'no_results': 'brak wyników',
			'in': 'w',
			'show_all_from_field': 'Pokaż wszystkie z tej dziedziny',
			'special_topic': 'Temat specjalny',
		},
		headings_details: {
			'content': "<strong>Zawartość</strong> działu",
			'content_desc': "W tym dziale znajdziesz zarówno materiały ogólne związane doktoratami honoris causa, jak również te, które związane są z konkretnymi instytucjami je przyznającymi oraz osobami, które je otrzymały. Aby przeglądać zawartość działu wybierz z listy poniżej zakes, który Cię interesuje. Materiały zostały usystematyzowane i pogrupowane, w celu łatwiejszego przeglądania.",
			'desc': '<strong>Opis</strong> działu',
			'location': '<strong>Lokalizacja</strong> działu',
			'show_details': 'Przejdź do działu',
			'domain': 'Dziedzina',
			'heading': 'Dział',
			'change_domain': 'Zmień dziedzinę',
			'contact': 'Kontakt z redaktorem działu',
			'error': 'Zgłoś błąd do Redaktora',
			'choose': 'Wybierz',
			'go_to': 'Przejdź do',
			'go_to_dest': {
				'journal': 'karty czasopisma',
				'person': 'karty osoby',
				'institution': 'karty instytucji',
				'journals': 'karty czasopism',
				'event': 'karty wydarzeń',
				'event-series': 'karty cykli wydarzeń',
				'publishing_house': 'karty wydawnictw',
			},
			'GENERAL_MATERIALS_GENERAL_MATERIAL': 'Materiały ogólne',
			'LITERARY_GENETICS_GENERAL_MATERIAL': 'Materiały ogólne',
			'LITERARY_GENETICS_MATERIALS_FOR_DICTIONARY': 'Materiały do "słownika rodzajów literackich"',
			'JOURNAL_GENERAL_MATERIAL': 'Materiały ogólne',
			'MATERIALS_ABOUT_JOURNAL': 'Materiały o czasopiśmie',
			'MATERIALS_ABOUT_JOURNAL_SINGLE': 'Materiały o czasopiśmie',
			'ACTIVITY_OF_JOURNAL': 'Działalność czasopisma',
			'ACTIVITY_OF_JOURNAL_SINGLE': 'Działalność czasopisma',
			'LITERARY_TEXT': 'Teksty literackie',
			'STUDY_TEXT': 'Materiały opracowaniowe',
			'CREATIVE_WRITING_GENERAL_MATERIAL': 'Materiały ogólne',
			'CREATIVE_WRITING_LITERARY_COUNSELING': 'Poradnictwo literackie',
			'BIBLE_TEXT': 'Teksty biblijne',
			'BIBLE_STUDY_TEXT': 'Materiały opracowaniowe',
			'ALL_INSTITUTIONS': 'Lista instytucji',
			'ALL_JOURNALS': 'Lista czasopism',
			'ALL_EVENTS': 'Lista wydarzeń',
			'ALL_PUBLISHING_HOUSES': 'Lista wydawnictw',
			'INSTITUTION_GENERAL_MATERIAL': 'Materiały ogólne',
			'MATERIALS_ABOUT_INSTITUTION': 'Materiały o instytucji',
			'MATERIALS_ABOUT_INSTITUTION_SINGLE': 'Materiały o instytucji',
			'ACTIVITY_OF_INSTITUTION': 'Działalność instytucji',
			'ACTIVITY_OF_INSTITUTION_SINGLE': 'Działalność instytucji',
			'PUBLISHING_HOUSE_GENERAL_MATERIAL': 'Materiały ogólne',
			'MATERIALS_ABOUT_PUBLISHING_HOUSE': 'Materiały o wydawnictwie',
			'MATERIALS_ABOUT_PUBLISHING_HOUSE_SINGLE': 'Materiały o wydawnictwie',
			'ACTIVITY_OF_PUBLISHING_HOUSE': 'Działalność wydawnictwa',
			'ACTIVITY_OF_PUBLISHING_HOUSE_SINGLE': 'Działalność wydawnictwa',
			'EVENT_GENERAL_MATERIAL': 'Materiały ogólne',
			'MATERIALS_ABOUT_EVENT': 'Zapowiedzi, omówienia, sprawozdania',
			'MATERIALS_ABOUT_EVENT_SINGLE': 'Zapowiedzi, omówienia, sprawozdania',
			'LINKED_EVENTS': 'Powiązane wydarzenia',
			'LINKED_EVENTS_SINGLE': 'Powiązane wydarzenia',
			'FEATURE_MOVIE_TYPE': 'Filmy fabularne pełnometrażowe',
			'TV_MOVIE_TYPE': 'Filmy telewizyjne',
			'DOCUMENTARY_MOVIE_TYPE': 'Filmy dokumentalne',
			'SERIES_MOVIE_TYPE': 'Seriale',
			'LITERARY_LIFE_NATIONWIDE_CULTURAL_EVENTS': 'Ogólnopolskie wydarzenia kulturalne',
			'LITERARY_LIFE_NATIONWIDE_CULTURAL_INSTITUTIONS': 'Ogólnopolskie instytucje kulturalne',
			'LITERARY_LIFE_NATIONWIDE_GENERAL_MATERIAL': 'Materiały ogólne',
			'TEXT_STUDIES': 'Materiały opracowaniowe',
			'LITERARY_LIFE_IN_CENTERS_ALL_PLACES': 'Lista miejscowości',
			'LITERARY_LIFE_IN_CENTERS_GENERAL_MATERIAL': 'Materiały ogólne',
			'LITERARY_LIFE_IN_CENTERS_GENERAL_MATERIAL_FOR_PLACE': 'Materiały ogólne',
			'LITERARY_LIFE_IN_CENTERS_GENERAL_MATERIAL_FOR_PLACE_SINGLE': 'Materiały ogólne',
			'LITERARY_LIFE_IN_CENTERS_CULTURAL_EVENTS': 'Wydarzenia kulturalne w miejscowości',
			'LITERARY_LIFE_IN_CENTERS_CULTURAL_EVENTS_SINGLE': 'Wydarzenia kulturalne w miejscowości',
			'LITERARY_LIFE_IN_CENTERS_CULTURAL_INSTITUTIONS': 'Instytucje kulturalne w miejscowości',
			'LITERARY_LIFE_IN_CENTERS_CULTURAL_INSTITUTIONS_SINGLE': 'Instytucje kulturalne w miejscowości',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_ALL_COUNTRIES': 'Lista krajów',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_GENERAL_MATERIAL': 'Materiały ogólne',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_GENERAL_MATERIAL_FOR_COUNTRY': 'Materiały ogólne',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_GENERAL_MATERIAL_FOR_COUNTRY_SINGLE': 'Materiały ogólne',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_EVENTS': 'Wydarzenia',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_EVENTS_SINGLE': 'Wydarzenia',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_INSTITUTIONS': 'Instytucje',
			'CONTACT_BETWEEN_POLISH_LITERATURE_AND_ABROAD_INSTITUTIONS_SINGLE': 'Instytucje',
			'ALL_PEOPLE': 'Lista osób',
			'PERSON_GENERAL_MATERIAL': 'Materiały ogólne',
			'PERSON_AUTHORSHIP': 'Autorstwo',
			'PERSON_AUTHORSHIP_SINGLE': 'Autorstwo',
			'PERSON_CO_CREATION': 'Współtwórstwo',
			'PERSON_CO_CREATION_SINGLE': 'Współtwórstwo',
			'PERSON_ACTIVITY': 'Materiały o osobie i jej działalności',
			'PERSON_ACTIVITY_SINGLE': 'Materiały o osobie i jej działalności',
			'PERSON_EVENTS': 'Udział w wydarzeniach',
			'PERSON_EVENTS_SINGLE': 'Udział w wydarzeniach',
			'PERSON_WORSHIP': 'Przejawy kultu',
			'PERSON_WORSHIP_SINGLE': 'Przejawy kultu',
			'PERSON_MENTION': 'Wzmianki',
			'PERSON_MENTION_SINGLE': 'Wzmianki',
			'HC_DOCTORATES_GENERAL_MATERIAL': 'Materiały ogólne',
			'HC_DOCTORATES_DOCTORATES': 'Doktoraty honoris causa',
			'HC_DOCTORATES_DOCTORATES_SINGLE': 'Doktoraty honoris causa',
			'HC_DOCTORATES_MATERIALS_ABOUT_DOCTORATES': 'Sprawozdania, omówienia, laudacje',
			'HC_DOCTORATES_MATERIALS_ABOUT_DOCTORATES_SINGLE': 'Sprawozdania, omówienia, laudacje',
			'THEATERS_IN_COUNTRY_ALL_PLACES': 'Lista miejscowości',
			'THEATERS_IN_COUNTRY_ALL_THEATERS': 'Lista teatrów',
			'THEATERS_IN_COUNTRY_GENERAL_MATERIAL': 'Materiały ogólne',
			'THEATERS_IN_COUNTRY_ACTIVITY_OF_THEATER': 'Omówienie działalności teatrów',
			'THEATERS_IN_COUNTRY_ACTIVITY_OF_THEATER_SINGLE': 'Omówienie działalności teatru',
			'THEATERS_IN_COUNTRY_REPERTOIRE': 'Repertuar teatrów',
			'THEATERS_IN_COUNTRY_REPERTOIRE_SINGLE': 'Repertuar teatru',
			'THEATERS_ABROAD_ALL_COUNTRIES': 'Lista krajów',
			'THEATERS_ABROAD_ALL_THEATERS': 'Lista teatrów',
			'THEATERS_ABROAD_GENERAL_MATERIAL': 'Materiały ogólne',
			'THEATERS_ABROAD_ACTIVITY_OF_THEATER': 'Omówienie działalności teatrów',
			'THEATERS_ABROAD_ACTIVITY_OF_THEATER_SINGLE': 'Omówienie działalności teatru',
			'THEATERS_ABROAD_REPERTOIRE': 'Repertuar teatrów',
			'THEATERS_ABROAD_REPERTOIRE_SINGLE': 'Repertuar teatru',
			'FOREIGN_THEATER_ALL_COUNTRIES': 'Lista krajów',
			'FOREIGN_THEATER_GENERAL_MATERIAL': 'Materiały ogólne',
			'CONTEMPORARY_REALIZATIONS_OF_POLISH_DRAMA_ABROAD_GENERAL_MATERIAL': 'Materiały ogólne',
			'CONTEMPORARY_REALIZATIONS_OF_POLISH_DRAMA_ABROAD_SPECTACLE': 'Spektakle',
			'THEATER_CONTACTS_WITH_FOREIGN_COUNTRIES_ALL_COUNTRIES': 'Lista krajów',
			'THEATER_CONTACTS_WITH_FOREIGN_COUNTRIES_ALL_THEATERS': 'Lista teatrów',
			'THEATER_CONTACTS_WITH_FOREIGN_COUNTRIES_GENERAL_MATERIAL': 'Materiały ogólne',
			'THEATER_CONTACTS_WITH_FOREIGN_COUNTRIES_GENERAL_MATERIAL_SINGLE': 'Materiały ogólne',
			'THEATER_CONTACTS_WITH_FOREIGN_COUNTRIES_SPECTACLE': 'Spektakle',
			'THEATER_CONTACTS_WITH_FOREIGN_COUNTRIES_SPECTACLE_SINGLE': 'Spektakle',
		},
		collections: {
			'about': 'Charakterystyka kolekcji PBL',
			'learn_more': 'Dowiedz się więcej',
			'in_brief': '<strong>W skrócie</strong> o kolekcjach',
			'collection': 'Kolekcja',
			'see_results': 'Przejdź do kolekcji',
		},
		item: {
			'annotation': 'Adnotacje',
			'no_info': 'Brak dodatkowych informacji.',
			'mainName': 'Właściwa forma nazwiska',
			'otherName': 'Inna forma nazwiska lub imienia',
			'journalSubtitle': 'Podtytuł',
			'authors': 'Autor/ka',
			'additionTo': 'Dodatek do',
			'contains': 'Zawiera',
			'seriesType': 'Rodzaj cyklu',
			'sources': 'Źródło czasopiśmiennicze',
			'triggerInstitution': 'Instytucja sprawcza',
			'publishingHouse': 'Wydawca, miejsce wydania',
			'subtype': 'Rodzaj instytucji',
			'subtypeEventSeries': 'Rodzaj cyklu wydarzeń',
			'location': 'Miejsce działalności',
			'alias': 'Pseudonim',
			'familyName': 'Nazwisko rodowe',
			'monasticName': 'Imię zakonne',
			'codename': 'Kryptonim',
			'subtypeEvent': 'Rodzaj wydarzenia',
			'edition': 'Edycja',
			'locationAndDateEvent': 'Miejsce i data wydarzenia',
			'awards': 'Laureaci/tki',
			'organizors': 'Organizator',
			'release_date': 'Data udostępnienia',
			'details': '<strong>Szczegóły</strong> zapisu',
			'details_card': '<strong>Szczegóły</strong> karty',
			'details_tab': 'Szczegóły karty',
			'yearbook_desc': 'Opracowane roczniki czasopisma',
			'yearbook_desc_header': 'Opracowane <strong>roczniki czasopisma</strong>',
			'yearbook_desc_tab': 'Opracowane roczniki',
			'bib_desc': 'Opis <strong>bibliograficzny</strong>',
			'external_links': '<strong>Linki</strong> zewnętrzne',
			'provenance': '<strong>Proweniencja</strong> informacji',
			'related_records': '<strong>Powiązane</strong> zapisy i kartoteki',
			'see_related': 'Zobacz wizualizację powiązań z obiektami bazy PBL',
			'phrase': 'Fraza w polu',
			'not_found': 'Nie znaleziono obiektu.',
			'next': 'Następny',
			'prev': 'Poprzedni',

			"eventseries.linkedCreativeWorks.authorsForSearch": "Materiał powiązany z utworem",
			"eventseries.creator": "Twórca",
			"eventseries.linkedRecordsTitles": "Materiał powiązany z zapisem",
			"eventseries.linkedCreativeWorks.titles.title": "Materiał powiązany z utworem",
			"eventseries.innerTags.name": "Nazwa",
			"eventseries.linkedSeries.authorsForSearch": "Materiał powiązany z cyklem",
			"eventseries.linkedPlacesForSearch": "Materiał powiązany z miesjcem",
			"eventseries.materialsAboutInstitution": "Materiał o instytucjach",
			"eventseries.linkedEventsForSearch": "Materiał powiązany z wydarzeniem",
			"eventseries.annotations": "Adnotacje",
			"eventseries.eventHeadings": "Działy",
			"eventseries.history.names.name": "Nazwa",
			"eventseries.externalLinks.url": "Linki zewnętrzne",
			"eventseries.eventTypeForSearch": "Typ",
			"eventseries.linkedSeries.titles.title": "Materiał powiązany z cyklem",
			"eventseries.organizers": "Organizator",
			"eventseries.materialsAboutJournal": "Materiał o czasopismach",
			"eventseries.remarks": "Adnotacje",
			"eventseries.originSources": "Źródło",
			"movie.linkedCreativeWorks.authorsForSearch": "Materiał powiązany z utworem",
			"movie.linkedRecordsTitles": "Materiał powiązany z zapisem",
			"movie.typesForSearch": "Typ",
			"movie.materialsAboutInstitution": "Materiał o instytucjach",
			"movie.recordHeadings": "Działy",
			"movie.annotations": "Adnotacje",
			"movie.coCreations.coCreators": "Osoby współtworzące",
			"movie.titles.title": "Tytuły",
			"movie.years": "Rok",
			"movie.externalLinks.url": "Linki zewnętrzne",
			"movie.linkedSeries.titles.title": "Materiał powiązany z cyklem",
			"movie.materialsAboutEvent": "Materiał o wydarzeniach",
			"movie.triggerInstitutions.history.names.name": "Instytucja sprawcza",
			"movie.materialsAboutJournal": "Materiał o czasopismach",
			"movie.principalTitle": "Tytuł podstawowy",
			"movie.creator": "Twórca",
			"movie.linkedCreativeWorks.titles.title": "Materiał powiązany z utworem",
			"movie.innerTags.name": "Nazwa",
			"movie.linkedSeries.authorsForSearch": "Materiał powiązany z cyklem",
			"movie.collectionsForSearch": "Kolekcje",
			"movie.filmStudios.history.names.name": "Wytwórnia",
			"movie.persons": "Osoba i jej funkcje",
			"movie.places": "Miejsce",
			"movie.recordForm": "Forma zapisu",
			"movie.coCreationTypes": "Typy współtwórstwa",
			"movie.remarks": "Adnotacje",
			"movie.originSources": "Źródło",
			"spectacle.linkedCreativeWorks.authorsForSearch": "Materiał powiązany z utworem",
			"spectacle.creator": "Twórca",
			"spectacle.linkedRecordsTitles": "Materiał powiązany z zapisem",
			"spectacle.linkedCreativeWorks.titles.title": "Materiał powiązany z utworem",
			"spectacle.innerTags.name": "Nazwa",
			"spectacle.linkedSeries.authorsForSearch": "Materiał powiązany z cyklem",
			"spectacle.typesForSearch": "Typ",
			"spectacle.materialsAboutInstitution": "Materiał o instytucjach",
			"spectacle.recordHeadings": "Działy",
			"spectacle.annotations": "Adnotacje",
			"spectacle.collectionsForSearch": "Kolekcje",
			"spectacle.coCreations.coCreators": "Osoby współtworzące",
			"spectacle.titles.title": "Tytuły",
			"spectacle.years": "Rok",
			"spectacle.persons": "Osoba i jej funkcje",
			"spectacle.externalLinks.url": "Linki zewnętrzne",
			"spectacle.recordForm": "Forma zapisu",
			"spectacle.coCreationTypes": "Typy współtwórstwa",
			"spectacle.premiereDescription.theater.history.names.name": "Teatr",
			"spectacle.linkedSeries.titles.title": "Materiał powiązany z cyklem",
			"spectacle.materialsAboutEvent": "Materiał o wydarzeniach",
			"spectacle.principalTitle": "Tytuł podstawowy",
			"spectacle.remarks": "Adnotacje",
			"spectacle.originSources": "Źródło",
			"radiotelevision.linkedCreativeWorks.authorsForSearch": "Materiał powiązany z utworem",
			"radiotelevision.linkedRecordsTitles": "Materiał powiązany z zapisem",
			"radiotelevision.typesForSearch": "Typ",
			"radiotelevision.materialsAboutInstitution": "Materiał o instytucjach",
			"radiotelevision.recordHeadings": "Działy",
			"radiotelevision.annotations": "Adnotacje",
			"radiotelevision.coCreations.coCreators": "Osoby współtworzące",
			"radiotelevision.titles.title": "Tytuły",
			"radiotelevision.years": "Rok",
			"radiotelevision.externalLinks.url": "Linki zewnętrzne",
			"radiotelevision.linkedSeries.titles.title": "Materiał powiązany z cyklem",
			"radiotelevision.materialsAboutEvent": "Materiał o wydarzeniach",
			"radiotelevision.materialsAboutJournal": "Materiał o czasopismach",
			"radiotelevision.principalTitle": "Tytuł podstawowy",
			"radiotelevision.creator": "Twórca",
			"radiotelevision.linkedCreativeWorks.titles.title": "Materiał powiązany z utworem",
			"radiotelevision.innerTags.name": "Nazwa",
			"radiotelevision.linkedSeries.authorsForSearch": "Materiał powiązany z cyklem",
			"radiotelevision.collectionsForSearch": "Kolekcje",
			"radiotelevision.belongingToSeries.titles.title": "Przynależność do cyklu",
			"radiotelevision.persons": "Osoba i jej funkcje",
			"radiotelevision.places": "Miejsce",
			"radiotelevision.recordForm": "Forma zapisu",
			"radiotelevision.coCreationTypes": "Typy współtwórstwa",
			"radiotelevision.remarks": "Adnotacje",
			"radiotelevision.originSources": "Źródło",
			"journalitem.linkedCreativeWorks.authorsForSearch": "Materiał powiązany z utworem",
			"journalitem.linkedRecordsTitles": "Materiał powiązany z zapisem",
			"journalitem.sources": "Źródło",
			"journalitem.typesForSearch": "Typ",
			"journalitem.materialsAboutInstitution": "Materiał o instytucjach",
			"journalitem.recordHeadings": "Działy",
			"journalitem.annotations": "Adnotacje",
			"journalitem.coCreations.coCreators": "Osoby współtworzące",
			"journalitem.titles.title": "Tytuły",
			"journalitem.years": "Rok",
			"journalitem.externalLinks.url": "Linki zewnętrzne",
			"journalitem.linkedSeries.titles.title": "Materiał powiązany z cyklem",
			"journalitem.materialsAboutEvent": "Materiał o wydarzeniach",
			"journalitem.materialsAboutJournal": "Materiał o czasopismach",
			"journalitem.principalTitle": "Tytuł podstawowy",
			"journalitem.creator": "Twórca",
			"journalitem.linkedCreativeWorks.titles.title": "Materiał powiązany z utworem",
			"journalitem.innerTags.name": "Nazwa",
			"journalitem.linkedSeries.authorsForSearch": "Materiał powiązany z cyklem",
			"journalitem.languagesForSearch": "Języki",
			"journalitem.collectionsForSearch": "Kolekcje",
			"journalitem.linkedPublishingSeries.titles.title": "Materiał powiązany z serią wydawniczą",
			"journalitem.belongingToSeries.titles.title": "Przynależność do cyklu",
			"journalitem.persons": "Osoba i jej funkcje",
			"journalitem.places": "Miejsce",
			"journalitem.recordForm": "Forma zapisu",
			"journalitem.anthologyDescription": "Opis antologii",
			"journalitem.coCreationTypes": "Typy współtwórstwa",
			"journalitem.remarks": "Adnotacje",
			"journalitem.originSources": "Źródło",
			"authorsbook.linkedCreativeWorks.authorsForSearch": "Materiał powiązany z utworem",
			"authorsbook.linkedRecordsTitles": "Materiał powiązany z zapisem",
			"authorsbook.typesForSearch": "Typ",
			"authorsbook.materialsAboutInstitution": "Materiał o instytucjach",
			"authorsbook.recordHeadings": "Działy",
			"authorsbook.annotations": "Adnotacje",
			"authorsbook.edition": "wydanie",
			"authorsbook.coCreations.coCreators": "Osoby współtworzące",
			"authorsbook.titles.title": "Tytuły",
			"authorsbook.years": "Rok",
			"authorsbook.externalLinks.url": "Linki zewnętrzne",
			"authorsbook.linkedSeries.titles.title": "Materiał powiązany z cyklem",
			"authorsbook.materialsAboutEvent": "Materiał o wydarzeniach",
			"authorsbook.triggerInstitutions.history.names.name": "Instytucja sprawcza",
			"authorsbook.materialsAboutJournal": "Materiał o czasopismach",
			"authorsbook.principalTitle": "Tytuł podstawowy",
			"authorsbook.creator": "Twórca",
			"authorsbook.linkedCreativeWorks.titles.title": "Materiał powiązany z utworem",
			"authorsbook.innerTags.name": "Nazwa",
			"authorsbook.linkedSeries.authorsForSearch": "Materiał powiązany z cyklem",
			"authorsbook.languagesForSearch": "Języki",
			"authorsbook.collectionsForSearch": "Kolekcje",
			"authorsbook.linkedPublishingSeries.titles.title": "Materiał powiązany z serią wydawniczą",
			"authorsbook.physicalDescription.description": "Opis",
			"authorsbook.belongingToSeries.titles.title": "Przynależność do cyklu",
			"authorsbook.persons": "Osoba i jej funkcje",
			"authorsbook.places": "Miejsce",
			"authorsbook.recordForm": "Forma zapisu",
			"authorsbook.coCreationTypes": "Typy współtwórstwa",
			"authorsbook.remarks": "Adnotacje",
			"authorsbook.originSources": "Źródło",
			"collectivebook.linkedCreativeWorks.authorsForSearch": "Materiał powiązany z utworem",
			"collectivebook.linkedRecordsTitles": "Materiał powiązany z zapisem",
			"collectivebook.typesForSearch": "Typ",
			"collectivebook.materialsAboutInstitution": "Materiał o instytucjach",
			"collectivebook.recordHeadings": "Działy",
			"collectivebook.annotations": "Adnotacje",
			"collectivebook.edition": "wydanie",
			"collectivebook.coCreations.coCreators": "Osoby współtworzące",
			"collectivebook.titles.title": "Tytuły",
			"collectivebook.years": "Rok",
			"collectivebook.externalLinks.url": "Linki zewnętrzne",
			"collectivebook.linkedSeries.titles.title": "Materiał powiązany z cyklem",
			"collectivebook.materialsAboutEvent": "Materiał o wydarzeniach",
			"collectivebook.triggerInstitutions.history.names.name": "Instytucja sprawcza",
			"collectivebook.materialsAboutJournal": "Materiał o czasopismach",
			"collectivebook.principalTitle": "Tytuł podstawowy",
			"collectivebook.creator": "Twórca",
			"collectivebook.linkedCreativeWorks.titles.title": "Materiał powiązany z utworem",
			"collectivebook.innerTags.name": "Nazwa",
			"collectivebook.linkedSeries.authorsForSearch": "Materiał powiązany z cyklem",
			"collectivebook.languagesForSearch": "Języki",
			"collectivebook.collectionsForSearch": "Kolekcje",
			"collectivebook.linkedPublishingSeries.titles.title": "Materiał powiązany z serią wydawniczą",
			"collectivebook.physicalDescription.description": "Opis",
			"collectivebook.belongingToSeries.titles.title": "Przynależność do cyklu",
			"collectivebook.persons": "Osoba i jej funkcje",
			"collectivebook.places": "Miejsce",
			"collectivebook.recordForm": "Forma zapisu",
			"collectivebook.coCreationTypes": "Typy współtwórstwa",
			"collectivebook.remarks": "Adnotacje",
			"collectivebook.originSources": "Źródło",
			"anthology.linkedCreativeWorks.authorsForSearch": "Materiał powiązany z utworem",
			"anthology.linkedRecordsTitles": "Materiał powiązany z zapisem",
			"anthology.typesForSearch": "Typ",
			"anthology.materialsAboutInstitution": "Materiał o instytucjach",
			"anthology.recordHeadings": "Działy",
			"anthology.annotations": "Adnotacje",
			"anthology.edition": "wydanie",
			"anthology.coCreations.coCreators": "Osoby współtworzące",
			"anthology.titles.title": "Tytuły",
			"anthology.years": "Rok",
			"anthology.externalLinks.url": "Linki zewnętrzne",
			"anthology.linkedSeries.titles.title": "Materiał powiązany z cyklem",
			"anthology.materialsAboutEvent": "Materiał o wydarzeniach",
			"anthology.triggerInstitutions.history.names.name": "Instytucja sprawcza",
			"anthology.materialsAboutJournal": "Materiał o czasopismach",
			"anthology.principalTitle": "Tytuł podstawowy",
			"anthology.creator": "Twórca",
			"anthology.linkedCreativeWorks.titles.title": "Materiał powiązany z utworem",
			"anthology.innerTags.name": "Nazwa",
			"anthology.linkedSeries.authorsForSearch": "Materiał powiązany z cyklem",
			"anthology.languagesForSearch": "Języki",
			"anthology.collectionsForSearch": "Kolekcje",
			"anthology.linkedPublishingSeries.titles.title": "Materiał powiązany z serią wydawniczą",
			"anthology.physicalDescription.description": "Opis",
			"anthology.belongingToSeries.titles.title": "Przynależność do cyklu",
			"anthology.persons": "Osoba i jej funkcje",
			"anthology.places": "Miejsce",
			"anthology.recordForm": "Forma zapisu",
			"anthology.coCreationTypes": "Typy współtwórstwa",
			"anthology.remarks": "Adnotacje",
			"anthology.originSources": "Źródło",
			"letters.linkedCreativeWorks.authorsForSearch": "Materiał powiązany z utworem",
			"letters.linkedRecordsTitles": "Materiał powiązany z zapisem",
			"letters.typesForSearch": "Typ",
			"letters.materialsAboutInstitution": "Materiał o instytucjach",
			"letters.recordHeadings": "Działy",
			"letters.annotations": "Adnotacje",
			"letters.edition": "wydanie",
			"letters.coCreations.coCreators": "Osoby współtworzące",
			"letters.titles.title": "Tytuły",
			"letters.years": "Rok",
			"letters.externalLinks.url": "Linki zewnętrzne",
			"letters.linkedSeries.titles.title": "Materiał powiązany z cyklem",
			"letters.materialsAboutEvent": "Materiał o wydarzeniach",
			"letters.triggerInstitutions.history.names.name": "Instytucja sprawcza",
			"letters.materialsAboutJournal": "Materiał o czasopismach",
			"letters.principalTitle": "Tytuł podstawowy",
			"letters.creator": "Twórca",
			"letters.linkedCreativeWorks.titles.title": "Materiał powiązany z utworem",
			"letters.innerTags.name": "Nazwa",
			"letters.linkedSeries.authorsForSearch": "Materiał powiązany z cyklem",
			"letters.languagesForSearch": "Języki",
			"letters.collectionsForSearch": "Kolekcje",
			"letters.linkedPublishingSeries.titles.title": "Materiał powiązany z serią wydawniczą",
			"letters.physicalDescription.description": "Opis",
			"letters.belongingToSeries.titles.title": "Przynależność do cyklu",
			"letters.persons": "Osoba i jej funkcje",
			"letters.places": "Miejsce",
			"letters.recordForm": "Forma zapisu",
			"letters.coCreationTypes": "Typy współtwórstwa",
			"letters.remarks": "Adnotacje",
			"letters.originSources": "Źródło",
			"person.placeOfBirth": "Miejsce urodzenia",
			"person.creator": "Twórca",
			"person.innerTags.name": "Nazwa",
			"person.dateOfDeath": "Data śmierci",
			"person.annotations": "Adnotacje",
			"person.dateOfBirth": "Data urodzenia",
			"person.placeOfDeath": "Miejsce śmierci",
			"person.personSex": "Płeć",
			"person.yearOfDeath": "Rok śmierci",
			"person.externalLinks.url": "Linki zewnętrzne",
			"person.personHeadings": "Działy",
			//   "person.names.name": "Nazewnictwo osoby",
			"person.remarks": "Adnotacje",
			"person.yearOfBirth": "Rok urodzenia",
			"person.originSources": "Źródło",
			"person.names.name": "Nazwa",
			"creativework.titles.title": "Tytuły",
			"creativework.annotations": "Adnotacje",
			"creativework.authorsForSearch": "Autorka",
			"journal.yearbooks": "Rocznik",
			"journal.creator": "Twórca",
			"journal.innerTags.name": "Nazwa",
			"journal.libraries": "biblioteki",
			"journal.annotations": "Adnotacje",
			"journal.abbreviation": "skrót",
			"journal.titles.title": "Tytuły",
			"journal.publishedTo": "Opublikowany do",
			"journal.signatures": "podpisy",
			"journal.publishedFrom": "Opublikowany od",
			"journal.externalLinks.url": "Linki zewnętrzne",
			"journal.publishingPlaces": "Miejsce wydawania",
			"journal.issn": "Numer ISSN",
			"journal.publishedInSeries": "Opublikowane w serii",
			"journal.journalHeadings": "Działy",
			"journal.remarks": "Adnotacje",
			"journal.originSources": "Źródło",
			"event.linkedCreativeWorks.authorsForSearch": "Materiał powiązany z utworem",
			"event.linkedRecordsTitles": "Materiał powiązany z zapisem",
			"event.linkedPlacesForSearch": "Materiał powiązany z miejscem",
			"event.materialsAboutInstitution": "Materiał o instytucjach",
			"event.linkedEventsForSearch": "Materiał powiązany z wydarzeniem",
			"event.annotations": "Adnotacje",
			"event.belongingToEventSeries.history.names.name": "Przynależność do cyklu wydarzeń",
			"event.externalLinks.url": "Linki zewnętrzne",
			"event.eventTypeForSearch": "Typ",
			"event.dateForSearch": "Data",
			"event.linkedSeries.titles.title": "Materiał powiązany z cyklem",
			"event.names.name": "Nazwa",
			"event.laureates": "Laureatka",
			"event.materialsAboutJournal": "Materiał o czasopismach",
			"event.period": "Za okres",
			"event.creator": "Twórca",
			"event.linkedCreativeWorks.titles.title": "Materiał powiązany z utworem",
			"event.innerTags.name": "Nazwa",
			"event.linkedSeries.authorsForSearch": "Materiał powiązany z cyklem",
			"event.eventHeadings": "Działy",
			"event.editionNumber": "Numer edycji wydarzenia",
			"event.places": "Miejsce wydarzenia",
			"event.organizers": "Organizator",
			"event.remarks": "Adnotacje",
			"event.originSources": "Źródło",
			"institution.externalLinks.url": "Linki zewnętrzne",
			"institution.places": "Miejsce działalności",
			"institution.creator": "Twórca",
			"institution.yearOfInstitution": "Okres działalności",
			"institution.innerTags.name": "Nazwa",
			"institution.institutionTypes": "typy instytucji",
			"institution.annotations": "Adnotacje",
			"institution.history.names.name": "Nazwa",
			"institution.institutionHeadings": "Działy",
			"institution.remarks": "Adnotacje",
			"institution.originSources": "Źródło",
			"series.creator": "Twórca",
			"series.innerTags.name": "Nazwa",
			"series.interviewers": "przeprowadzający wywiad",
			"series.authorsForSearch": "Autorzy",
			"series.annotations": "Adnotacje",
			"series.titles.title": "Tytuły",
			"series.sourcesForSearch": "Źródło",
			"series.persons": "Osoba i jej funkcje",
			"series.addressees": "Adresaci",
			"series.externalLinks.url": "Linki zewnętrzne",
			"series.formForSearch": "Forma",
			"series.addresses": "Adresaci",
			"series.interlocutors": "Rozmówcy",
			"series.seriesHeadings": "Działy",
			"series.remarks": "Adnotacje",
			"series.seriesTypeForSearch": "Cykle",
			"series.originSources": "Źródło",
			"publishingseries.annotations": "Adnotacje",
			"publishingseries.principalTitle": "Tytuł podstawowy",
			"publishingseries.remarks": "Uwagi",
			"collectivebookcontent.linkedCreativeWorks.authorsForSearch": "Materiał powiązany z utworem",
			"collectivebookcontent.linkedRecordsTitles": "Materiał powiązany z zapisem",
			"collectivebookcontent.typesForSearch": "Typ",
			"collectivebookcontent.interviewers": "przeprowadzający wywiad",
			"collectivebookcontent.materialsAboutInstitution": "Materiał o instytucjach",
			"collectivebookcontent.recordHeadings": "Działy",
			"collectivebookcontent.annotations": "Adnotacje",
			"collectivebookcontent.coCreations.coCreators": "Osoby współtworzące",
			"collectivebookcontent.titles.title": "Tytuły",
			"collectivebookcontent.years": "Rok",
			"collectivebookcontent.externalLinks.url": "Linki zewnętrzne",
			"collectivebookcontent.linkedSeries.titles.title": "Materiał powiązany z cyklem",
			"collectivebookcontent.materialsAboutEvent": "Materiał o wydarzeniach",
			"collectivebookcontent.materialsAboutJournal": "Materiał o czasopismach",
			"collectivebookcontent.chapterTitles.title": "Tytuł rozdziału",
			"collectivebookcontent.principalTitle": "Tytuł podstawowy",
			"collectivebookcontent.addresses": "Adresaci",
			"collectivebookcontent.interlocutors": "Rozmówcy",
			"collectivebookcontent.creator": "Twórca",
			"collectivebookcontent.linkedCreativeWorks.titles.title": "Materiał powiązany z utworem",
			"collectivebookcontent.innerTags.name": "Nazwa",
			"collectivebookcontent.linkedSeries.authorsForSearch": "Materiał powiązany z cyklem",
			"collectivebookcontent.languagesForSearch": "Języki",
			"collectivebookcontent.collectionsForSearch": "Kolekcje",
			"collectivebookcontent.linkedPublishingSeries.titles.title": "Materiał powiązany z serią wydawniczą",
			"collectivebookcontent.persons": "Osoba i jej funkcje",
			"collectivebookcontent.addressees": "Adresaci",
			"collectivebookcontent.places": "Miejsce",
			"collectivebookcontent.recordForm": "Forma zapisu",
			"collectivebookcontent.anthologyDescription": "Opis antologii",
			"collectivebookcontent.coCreationTypes": "Typy współtwórstwa",
			"collectivebookcontent.remarks": "Adnotacje",
			"collectivebookcontent.originSources": "Źródło",
			"anthologycontent.linkedCreativeWorks.authorsForSearch": "Materiał powiązany z utworem",
			"anthologycontent.linkedRecordsTitles": "Materiał powiązany z zapisem",
			"anthologycontent.typesForSearch": "Typ",
			"anthologycontent.interviewers": "przeprowadzający wywiad",
			"anthologycontent.materialsAboutInstitution": "Materiał o instytucjach",
			"anthologycontent.recordHeadings": "Działy",
			"anthologycontent.annotations": "Adnotacje",
			"anthologycontent.coCreations.coCreators": "Osoby współtworzące",
			"anthologycontent.titles.title": "Tytuły",
			"anthologycontent.years": "Rok",
			"anthologycontent.externalLinks.url": "Linki zewnętrzne",
			"anthologycontent.linkedSeries.titles.title": "Materiał powiązany z cyklem",
			"anthologycontent.materialsAboutEvent": "Materiał o wydarzeniach",
			"anthologycontent.materialsAboutJournal": "Materiał o czasopismach",
			"anthologycontent.chapterTitles.title": "Tytuł rozdziału",
			"anthologycontent.principalTitle": "Tytuł podstawowy",
			"anthologycontent.addresses": "Adresaci",
			"anthologycontent.interlocutors": "Rozmówcy",
			"anthologycontent.creator": "Twórca",
			"anthologycontent.linkedCreativeWorks.titles.title": "Materiał powiązany z utworem",
			"anthologycontent.innerTags.name": "Nazwa",
			"anthologycontent.linkedSeries.authorsForSearch": "Materiał powiązany z cyklem",
			"anthologycontent.languagesForSearch": "Języki",
			"anthologycontent.collectionsForSearch": "Kolekcje",
			"anthologycontent.linkedPublishingSeries.titles.title": "Materiał powiązany z serią wydawniczą",
			"anthologycontent.persons": "Osoba i jej funkcje",
			"anthologycontent.addressees": "Adresaci",
			"anthologycontent.places": "Miejsce",
			"anthologycontent.recordForm": "Forma zapisu",
			"anthologycontent.anthologyDescription": "Opis antologii",
			"anthologycontent.coCreationTypes": "Typy współtwórstwa",
			"anthologycontent.remarks": "Adnotacje",
			"anthologycontent.originSources": "Źródło",
			"authorsbookcontent.linkedCreativeWorks.authorsForSearch": "Materiał powiązany z utworem",
			"authorsbookcontent.linkedRecordsTitles": "Materiał powiązany z zapisem",
			"authorsbookcontent.typesForSearch": "Typ",
			"authorsbookcontent.interviewers": "przeprowadzający wywiad",
			"authorsbookcontent.materialsAboutInstitution": "Materiał o instytucjach",
			"authorsbookcontent.recordHeadings": "Działy",
			"authorsbookcontent.annotations": "Adnotacje",
			"authorsbookcontent.coCreations.coCreators": "Osoby współtworzące",
			"authorsbookcontent.titles.title": "Tytuły",
			"authorsbookcontent.years": "Rok",
			"authorsbookcontent.externalLinks.url": "Linki zewnętrzne",
			"authorsbookcontent.linkedSeries.titles.title": "Materiał powiązany z cyklem",
			"authorsbookcontent.materialsAboutEvent": "Materiał o wydarzeniach",
			"authorsbookcontent.materialsAboutJournal": "Materiał o czasopismach",
			"authorsbookcontent.chapterTitles.title": "Tytuł rozdziału",
			"authorsbookcontent.principalTitle": "Tytuł podstawowy",
			"authorsbookcontent.addresses": "Adresaci",
			"authorsbookcontent.interlocutors": "Rozmówcy",
			"authorsbookcontent.creator": "Twórca",
			"authorsbookcontent.linkedCreativeWorks.titles.title": "Materiał powiązany z utworem",
			"authorsbookcontent.innerTags.name": "Nazwa",
			"authorsbookcontent.linkedSeries.authorsForSearch": "Materiał powiązany z cyklem",
			"authorsbookcontent.languagesForSearch": "Języki",
			"authorsbookcontent.collectionsForSearch": "Kolekcje",
			"authorsbookcontent.linkedPublishingSeries.titles.title": "Materiał powiązany z serią wydawniczą",
			"authorsbookcontent.persons": "Osoba i jej funkcje",
			"authorsbookcontent.addressees": "Adresaci",
			"authorsbookcontent.places": "Miejsce",
			"authorsbookcontent.recordForm": "Forma zapisu",
			"authorsbookcontent.anthologyDescription": "Opis antologii",
			"authorsbookcontent.coCreationTypes": "Typy współtwórstwa",
			"authorsbookcontent.remarks": "Adnotacje",
			"authorsbookcontent.originSources": "Źródło",
			"letterscontent.linkedCreativeWorks.authorsForSearch": "Materiał powiązany z utworem",
			"letterscontent.linkedRecordsTitles": "Materiał powiązany z zapisem",
			"letterscontent.typesForSearch": "Typ",
			"letterscontent.interviewers": "przeprowadzający wywiad",
			"letterscontent.materialsAboutInstitution": "Materiał o instytucjach",
			"letterscontent.recordHeadings": "Działy",
			"letterscontent.annotations": "Adnotacje",
			"letterscontent.coCreations.coCreators": "Osoby współtworzące",
			"letterscontent.titles.title": "Tytuły",
			"letterscontent.years": "Rok",
			"letterscontent.externalLinks.url": "Linki zewnętrzne",
			"letterscontent.linkedSeries.titles.title": "Materiał powiązany z cyklem",
			"letterscontent.materialsAboutEvent": "Materiał o wydarzeniach",
			"letterscontent.materialsAboutJournal": "Materiał o czasopismach",
			"letterscontent.chapterTitles.title": "Tytuł rozdziału",
			"letterscontent.principalTitle": "Tytuł podstawowy",
			"letterscontent.interlocutors": "Rozmówcy",
			"letterscontent.creator": "Twórca",
			"letterscontent.linkedCreativeWorks.titles.title": "Materiał powiązany z utworem",
			"letterscontent.innerTags.name": "Nazwa",
			"letterscontent.linkedSeries.authorsForSearch": "Materiał powiązany z cyklem",
			"letterscontent.languagesForSearch": "Języki",
			"letterscontent.collectionsForSearch": "Kolekcje",
			"letterscontent.linkedPublishingSeries.titles.title": "Materiał powiązany z serią wydawniczą",
			"letterscontent.persons": "Osoba i jej funkcje",
			"letterscontent.addressees": "Adresaci",
			"letterscontent.places": "Miejsce",
			"letterscontent.recordForm": "Forma zapisu",
			"letterscontent.anthologyDescription": "Opis antologii",
			"letterscontent.coCreationTypes": "Typy współtwórstwa",
			"letterscontent.remarks": "Adnotacje",
			"letterscontent.originSources": "Źródło",

			record: {
				'parent': 'Zawarty w',
				'journal': 'Czasopismo',
				'journal-item': 'Materiał w czasopiśmie',
				'journal-number': 'Numer czasopisma',
				'event-series': 'Cykl wydarzeń',
				'institution': 'Instytucja',
				'series': 'Cykl',
				'place': 'Miejscowość',
				'creative-work': 'Utwór',
				'event': 'Wydarzenie',
				'movie': 'Film',
				'authors-book': 'Książka',
				'spectacle': 'Spektakl',
				'radio': 'Radio',
				'television': 'Telewizja',
				'countries': 'Produkcja',
				'publicationLanguage': 'Język publikacji',
				'annotations': 'Adnotacje',
				'coCreators': 'Osoby współtworzące',
				'title': 'Tytuł',
				'titleOriginal': 'Tytuł oryginału',
				'titleOriginalLang': 'Język oryginału',
				'translationBase': 'Tytuł podstawy przekładu',
				'translationBaseLang': 'Język podstawy przekładu',
				'dedication': 'Dedykacja',
				'types': 'Rodzaj zapisu',
				'locations': 'Miejsce wydania',
				'publicationYear': 'Rok wydania',
				'edition': 'Wydanie',
				'contents': 'Zawiera także',
				'publishingHouses': 'Wydawnictwo',
				'typesAndKind': 'Rodzaj i typ zapisu',
				'radioType': 'Rodzaj zapisu',
				'televisionType': 'Rodzaj zapisu',
				'headings': 'Dziedzina i dział główny',
				'secondaryHeadings': 'Dziedzina i dział poboczny',
				'linkedFilesAndRecords': 'Dotyczy',
				'productionYear': 'Rok produkcji',
				'producersAndFilmStudios': 'Wytwórnia/wytwórca',
				'triggerInstitutions': 'Instytucja sprawcza',
				'collections': 'Kolekcja PBL',
				'externalLinks': 'Identyfikator zewnętrzny',
				'authors': 'Autor/ka',
				'physicalDescription': 'Opis fizyczny',
				'premiereYear': 'Rok premiery',
				'belongingToSeries': 'Przynależność do cyklu',
				'anthologyDesc': 'Zawartość antologii',
				'source': 'Inne źródło',
				'sourceOrigin': 'Źródło',
				'authorCompany': 'Autor/ka',
				'theater': 'Teatr',
				'resumptions': 'Lata wznowień',
				'premiere': 'Rok premiery',
				'mailingParts': 'Strony korespondencji',
				'interviewParts': 'Strony wywiadu',
				'incipitTitle': 'Tytuł (incipit)',
				'incipit': 'Incipit',
				'external-identifier': 'Identyfikator zewnętrzny',
				'broader-description-access': 'Dostęp do szerszego opisu',
				'online-access': 'Dostęp on-line',
				'other': 'Inne',
				'partTitle': 'Tytuł części',
				'chapterTitle': 'Tytuł rozdziału',
				'partDedication': 'Dedykacja części',
				'pagesRange': 'Strony',
				'belongingpublishingSeries': 'Przynależność do serii'
			},
			card: {
				'authors': 'Autor/ka',
				'title': 'Tytuł',
				'baseTitle': 'Tytuł',
				'translationBase': 'Tytuł podstawy przekładu',
				'translationBaseLang': 'Język podstawy przekładu',
				'originalTitle': 'Tytuł oryginału',
				'titleOriginalLang': 'Język oryginału',
				'incipit': 'Incipit',
				'otherTitleEvent': 'Inne formy nazwy wydarzenia',
				'otherTitle': 'Inne formy tytułu',
				'contains': 'Dodatek do',
				'previousTitle': 'Poprzedni tytuł',
				'nextTitle': 'Kontynuacja',
				'publishedFromTo': 'Okres wydawania',
				'typesEvent': 'Rodzaj wydarzenia',
				'typesSeries': 'Forma, rodzaj i typ cyklu',
				'edition': 'Edycja',
				'mailingParts': 'Strony korespondencji',
				'interviewParts': 'Strony wywiadu',
				'sources': 'Źródło',
				'incipitTitle': 'Tytuł (incipit:)',
				'locationsEvent': 'Miejsce wydarzenia',
				'dateEvent': 'Data wydarzenia',
				'organizersEvent': 'Organizator wydarzenia',
				'awards': 'Laureaci/tki',
				'belongingToEventSeries': 'Przynależność do cyklu wydarzeń',
				'linkedFilesAndRecords': 'Dotyczy',
				'headings': 'Dziedzina i dział główny',
				'secondaryHeadings': 'Dziedzina i dział poboczny',
				'annotations': 'Adnotacje',
				'external-identifier': 'Identyfikator zewnętrzny',
				'broader-description-access': 'Dostęp do szerszego opisu',
				'online-access': 'Dostęp on-line',
				'other': 'Inne',
				'relationsEvent': 'Relacje z innymi wydarzeniami',
				'parent': 'Zawiera się w',
				'publicationFrequency': 'Częstotliwość wydawania',
				'characters': 'Charakter czasopisma',
				'triggerInstitutions': 'Instytucja sprawcza',
				'publishingHouses': 'Wydawca',
				'places': 'Miejsce wydania',
				'publishingSeries': 'Seria',
				'issn': 'ISSN',
				'physicalDeficiencies': 'Braki fizyczne',
				'additionTo': 'Zawiera',
				'unitTitle': 'Tytuł jednostkowy',
				'dedication': 'Dedykacja',
				'subordinate': 'Zawiera',
				'previous': 'Jest poprzednikiem',
				'next': 'Jest następcą',
				'relationPeriod': 'Okres obowiązywania relacji z powyższym wydarzeniem',
				'mainName': 'Właściwa forma nazwiska i imienia',
				'alias': 'Pseudonim',
				'familyName': 'Nazwisko rodowe',
				'monasticName': 'Imię zakonne',
				'codename': 'Kryptonim',
				'otherName': 'Inna forma nazwiska lub imienia',
				'groupAlias': 'Pseudonim zbiorowy',
				'authorCompany': 'Spółka autorska',
				'birthDate': 'Data urodzenia',
				'birthLocation': 'Miejsce urodzenia',
				'deathDate': 'Data śmierci',
				'deathLocation': 'Miejsce śmierci',
				'sex': 'Płeć',
				'source': 'Inne źródło',
				'sourceOrigin': 'Źródło',
				'journal': 'Czasopismo',
				'journal-item': 'Materiał w czasopiśmie',
				'journal-number': 'Numer czasopisma',
				'otherNames': 'Inne formy nazwy cyklu wydarzeń',
				'otherNamesEventSeries': 'Okres funkcjonowania cyklu pod tą nazwą',
				'typesEventSeries': 'Rodzaj cyklu wydarzeń',
				'typesInstitution': 'Rodzaj instytucji',
				'organizers': 'Organizator',
				'relationsEventSeries': 'Relacje z innymi cyklami wydarzeń',
				'namePeriodInfoCycle': 'Okres funkcjonowania cyklu pod tą nazwą',
				'namePeriodInfo': 'Okres działalności pod tą nazwą',
				'namePlaces': 'Miejsce działalności',
				'otherNamesPlacesInstitution': 'Miejsce działalności instytucji pod tą nazwą',
				'otherNamesInstitution': 'Inne formy nazwy instytucji',
				'relationsInstitution': 'Relacje z innymi instytucjami',
				'choose_heading': 'Wybierz dział',
				'go_heading': 'Przejdź do działu',
				'show_results': 'Zobacz wyniki',
				'heading_structure': 'Struktura dziedziny',
				'literature-theory': 'Teoria literatury',
				'polish-literature': 'Literatura polska',
				'foreign-literature': 'Literatury obce',
				'movie-theatre-rtv': 'Teatr, film, radio i telewizja',

				'in_heading': 'w dziale',
				'person_in_heading': 'Przeglądaj twórczość osoby',
				'institution_in_heading': 'Przeglądaj materiały dotyczące instytucji',
				'event-series_in_heading': 'Przeglądaj materiały dotyczące cyklu wydarzeń',
				'event_in_heading': 'Przeglądaj materiały dotyczące wydarzenia',
				'creative-work_in_heading': 'Przeglądaj materiały dotyczące utworu',
				'journal-number_in_heading': 'Przeglądaj materiały dotyczące numeru czasopisma',
				'journal_in_heading': 'Przeglądaj materiały dotyczące czasopisma',
				'series_in_heading': 'Przeglądaj materiały dotyczące cyklu',

				'person_in_heading_results': 'Przejdź do <span>wyników wyszukiwania</span> dotyczących osoby:',
				'institution_in_heading_results': 'Przejdź do <span>wyników wyszukiwania</span> dotyczących instytucji:',
				'event-series_in_heading_results': 'Przejdź do <span>wyników wyszukiwania</span> dotyczących cyklu wydarzeń:',
				'event_in_heading_results': 'Przejdź do <span>wyników wyszukiwania</span> dotyczących wydarzenia:',
				'creative-work_in_heading_results': 'Przejdź do <span>wyników wyszukiwania</span> dotyczących utworu:',
				'journal-number_in_heading_results': 'Przejdź do <span>wyników wyszukiwania</span> dotyczących numeru czasopisma:',
				'journal_in_heading_results': 'Przejdź do <span>wyników wyszukiwania</span> dotyczących czasopisma:',
				'series_in_heading_results': 'Przejdź do <span>wyników wyszukiwania</span> dotyczących cyklu:',
			},
			item_type: {
				'journal': 'Czasopismo',
				'journal-item': 'Materiał w czasopiśmie',
				'journal-number': 'Numer czasopisma',
				'event-series': 'Cykl wydarzeń',
				'institution': 'Instytucja',
				'publishing-series': 'Seria wydawnicza',
				'series': 'Cykl',
				'content': 'Materiał w książce',
				'book': 'Książka',
				'place': 'Miejscowość',
				'creative-work': 'Utwór',
				'event': 'Wydarzenie',
				'movie': 'Film',
				'authors-book': 'Książka',
				'spectacle': 'Spektakl',
				'radio': 'Audycja radiowa',
				'television': 'Program telewizyjny',
				'rtv': 'Radio i telewizja',
				'anthologyDesc': 'Opis',
				'anthTypes': 'Typ utworu w antologii',
				'anthAuthors': 'Autor/ka',
				'anthTranslators': 'Tłumacz/ka',
				'mailAddressee': 'Adresat/ka korespondencji',
				'mailSender': 'Nadawca/czyni korespondencji',
				'mailDescription': 'Opis i relacje stron',
				'interInterviewer': 'Osoba przeprowadzająca wywiad',
				'interInterlocutor': 'Rozmówca/czyni wywiadu',
			},
			item_types: {
				'creative-work': 'Utwory',
				'records': 'Zapisy',
				'content': 'Materiały w książce',
				'event': 'Wydarzenia',
				'journal': 'Czasopisma',
				'journal-item': 'Materiały w czasopiśmach',
				'publishing-series': 'Serie wydawnicze',
				'event-series': 'Cykle wydarzeń',
				'institution': 'Instytucje',
				'series': 'Cykle',
				'place': 'Miejscowości',
			},
			types: {
				'person': 'Karta osoby',
				'publishing_series': 'Karta serii wydawniczej',
				'institution': 'Karta instytucji',
				'journal': 'Karta czasopisma',
				'journal-year': 'Rocznik czasopisma',
				'journal-number': 'Karta numeru czasopisma',
				'work': 'Karta utworu',
				'event': 'Karta wydarzenia',
				'event-series': 'Karta cyklu wydarzeń',
				'series': 'Karta cyklu',
				'book': 'Książka',
				'content': 'Materiał w książce',
				'creative-work': 'Karta utworu',
				'movie': 'Film',
				'spectacle': 'Spektakl teatralny',
				'publishing-series': 'Seria wydawnicza',
				'journal-item': 'Materiał w czasopiśmie',
				'radio': 'Audycja radiowa',
				'television': 'Program telewizyjny',
				'authors-book': 'Książka autorska',
				'authors_book': 'Książka autorska',
				'collective-book': 'Książka zbiorowa',
				'anthology': 'Antologia',
				'letters': 'Listy i korespondencja',
				'authors-book-content': 'Zawartość książki autorskiej',
				'collective-book-content': 'Zawartość książki zbiorowej',
				'anthology-content': 'Zawartość antologii',
				'letters-content': 'Zawartość listów i korespondencji',
				'resumptionsBroadcasts': 'Daty emisji',
				'resumptionsProgram': 'Program emisji',
				type: {
					'person': 'osoby',
					'publishing_series': 'serii wydawniczej',
					'institution': 'instytucji',
					'journal': 'czasopisma',
					'journal-year': 'roczniku czasopisma',
					'journal-number': 'numeru czasopisma',
					'work': 'utworu',
					'event': 'wydarzenia',
					'event-series': 'cyklu wydarzeń',
					'series': 'cyklu',
					'book': 'książki',
					'content': 'materiału w książce',
					'creative-work': 'utworu',
					'movie': 'filmu',
					'spectacle': 'spektaklu teatralnego',
					'publishing-series': 'serii wydawniczej',
					'journal-item': 'materiału w czasopiśmie',
					'radio': 'audycji radiowej',
					'television': 'programu telewizyjnego',
					'authors-book': 'książki autorskiej',
					'authors_book': 'książki autorskiej',
					'collective-book': 'książki zbiorowej',
					'anthology': 'antologii',
					'letters': 'listu i korespondencji',
				}
			},
			cards: {
				'person_card': 'Karta osoby',
				'institution_card': 'Karta instytucji',
				'event_cycle_card': 'Karta cyklu wy darzeń',
				'event_card': 'Karta wydarzenia',
				'work_card': 'Karta Utworu',
				'journal_card': 'Karta czasopisma',
				'journal-number_card': 'Karta numeru czasopisma',
				'publishing-series_card': 'Karta serii wydawniczej',
				'event-series_card': 'Karta cyklu wydarzeń',
				'card_id': 'ID',
				'yearbooks': 'Roczniki',
				'yearbooks_number': 'Łączna liczba zapisów',
				'yearbooks_warning': 'Uwaga',
				'yearbooks_cause': 'Powód',
				'yearbooks_info': 'Aktualne czasopismo nie podlega już opracowywaniu.',
				'show_yearbook_details': 'Pokaż szczegóły numeru',
				'dedication': 'Dedykacja',
				'description': 'Uwaga',
				'as_book': 'jako książka',
				'is_developed': 'Uwaga: Ten numer czasopisma jest opracowany w naszej bazie',
			},
			authors_book: {
				'bibliographic_text': 'Opis bibliograficzny',
				'record_details': 'Szczegoły zapisu',
				'edition_year': 'Rok wydania',
				'location': 'Miejsce wydania',
				'phisical_description': 'Opis fizyczny'
			},
			person: {
				'valid_name': 'Właściwa forma nazwiska i imienia',
				'alias': 'Pseudonim',
				'family_name': 'Nazwisko rodowe',
				'monastic_name': 'Imię zakonne',
				'other_name': 'Inna forma imienia',
				'other_surname': 'Inna forma nazwiska',
				'collective_alias': 'Pseudonim zbiorowy',
				'authors_company': 'Społka autorska',
				'codename': 'Kryptonim',
				'pbl_field': 'Dziedzina i dział PBL',
				'annotation': 'Adnotacja',
				'birth_date': 'Data urodzenia',
				'birth_location': 'Miejsce urodzenia',
				'death_date': 'Data śmierci',
				'death_location': 'Miejsce śmierci',
				'sex': 'Płeć'
			},
			institution: {
				'activity_time': 'Okres działalności pod tą nazwą',
				'activity_location': 'Miejsce działalności',
				'other_names': 'Inne formy nazwy instytucji',
				'types': 'Rodzaj instytucji',
				'relations': 'Relacje z innymi instytucjami',
				'pbl_field': 'Dziedzina i dział PBL',
				'annotation': 'Adnotacje',
			},
			journal: {
				'other_titles': 'Inne formy tytułu',
				'addition': 'Dodatek do',
				'includes': 'Zawiera',
				'previous_title': 'Poprzedni tytuł',
				'continuation': 'Kontynuacja',
				'nature': 'Charakter czasopisma',
				'frequency': 'Częstotliwość wydawania',
				'executive_body': 'Instytucja sprawcza',
				'publisher': 'Wydawca',
				'place_of_publication': 'Miejsce wydania',
				'publishingPeriod': 'Okres wydawania',
				'series': 'Seria',
				'issn': 'ISSN',
				'pbl_field': 'Dziedzina i dział PBL',
				'annotation': 'Adnotacje',
				'journal_volume': 'Opracowane roczniki czasopisma',
			},
			journal_number: {
				'unit_title': 'Tytuł jednostkowy',
				'dedication': 'Dedykacja',
				'addition': 'Dodatek do',
				'nature': 'Charakter czasopisma',
				'executive_body': 'Instytucja sprawcza',
				'publisher': 'Wydawca',
				'place_of_publication': 'Miejsce wydania',
				'series': 'Seria',
				'issn': 'ISSN',
				'physical_deficiency': 'Braki fizyczne',
				'pbl_field': 'Dziedzina i dział PBL',
				'annotation': 'Adnotacje',
			},
			work: {
				'author': 'Autor',
				'title': 'Tytuł',
				'base_title': 'Tytuł podstawy przekładu',
				'base_language': 'Język podstawy przekładu',
				'original_title': 'Tytuł oryginału',
				'original_language': 'Język oryginału',
				'incipit': 'Incipit',
				'pbl_field': 'Dziedzina i dział PBL',
				'annotation': 'Adnotacje',
			},
			publishing_series: {
				'title': 'Tytuł',
				'base_title': 'Tytuł podstawy przekładu',
				'base_language': 'Język podstawy przekładu',
				'original_title': 'Tytuł oryginału',
				'original_language': 'Język oryginału',
				'subtitle': 'Podtytuł serii',
				'base_subtitle': 'Podtytuł podstawy przekładu',
				'base_language_subtitle': 'Język podstawy przekładu',
				'original_subtitle': 'Podtytuł oryginału',
				'original_language_subtitle': 'Język oryginału',
				'editor': 'Redaktor serii',
				'publisher': 'Wydawnictwo',
				'annotation': 'Adnotacje',
			},
			event_series: {
				'activity_time': 'Okres funkcjonowania cyklu pod tą nazwą',
				'other_names': 'Inne formy cyklu wydarzeń',
				'type': 'Rodzaj cyklu wydarzeń',
				'organizer': 'Organizator',
				'relations': 'Relacje z innymi cyklami wydarzeń',
				'concerns': 'Dotyczy',
				'pbl_field': 'Dziedzina i dział PBL',
				'annotation': 'Adnotacje',
			},
			series: {
				'type': 'Rodzaj cyklu',
				'author': 'Autor',
				'title': 'Tytuł',
				'base_title': 'Tytuł podstawy przekładu',
				'base_language': 'Język podstawy przekładu',
				'original_title': 'Tytuł oryginału',
				'original_language': 'Język oryginału',
				'dedication': 'Dedykacja',
				'incipit': 'Incipit',
				'pbl_field': 'Dziedzina i dział PBL',
				'correspondence_sides': 'Strony korespondencji',
				'interview_sides': 'Strony wywiadu',
				'annotation': 'Adnotacje',
				'source': 'Źrodło'
			},
			event: {
				'other_name': 'Inne formy nazwy wydarzenia',
				'type': 'Rodzaj wydarzenia',
				'edition': 'Edycja',
				'place': 'Miejsce wydarzenia',
				'date': 'Data wydarzenia',
				'organizer': 'Organizator wydarzenia',
				'winners': 'Laureaci/tki',
				'series': 'Przynależność do cyklu wydarzeń',
				'relations': 'Relacje z innymi wydarzeniami',
				'concerns': 'Dotyczy',
				'pbl_field': 'Dziedzina i dział PBL',
				'annotation': 'Adnotacje',
			},
		},
		results: {
			'other_result': 'Szukaną frazę znaleźiono także w nazwie działu PBL',
			'no_results': 'Brak wyników.',
			'wrong_query': 'Błąd zapytania.',
			'tab_content_error': 'Nie można załadować filtrow.',
			'back_to': 'Powrót do wyników wyszukiwania',
			'chosen_filters': 'Wybrane filtry',
			'remember_filters': 'Zablokuj filtry',
			'info': 'Zaznacz, jeśli chcesz by aktualnie wybrane filtry zostały zastosowane do następnego zapytania.',
			'delete_value': 'Usuń wartość',
			'clear_filters': 'Wyczyść filtry',
			'get_all_filters': 'Załaduj wszystkie filtry',
			'date_from': 'Data od',
			'date_to': 'Data do',
			'date_placeholder': 'DD.MM.RRRR',
			'year_placeholder': 'RRRR',
			'no_filters': 'Brak filtrów spełniających kryteria wyszukiwania.',
			'related_record': 'Materiały powiązane',
			'field_section': 'Dziedziny i dział zapisu',
			'field': 'Dziedzina',
			'headings': 'Dział główny',
			'headings_secondary': 'Dział poboczny',
			'secondaryHeadings': 'Dział poboczny',
			'show_fields': 'Zobacz dziedziny i działy',
			'choose_filters': 'Wybierz filtry',
			'filters': 'Filtry',
			'choose_sorting': 'Wybierz sposób sortowania',
			'search_for': 'Wpisz pierwszą literę lub szukaną frazę',
			'submit': 'Wybierz',
			'close': 'Zamknij',
			'bc': 'p.n.e.',
			'csv': 'Pobierz plik CSV',
			'api': 'Pobierz plik API',
			'no_results_title': 'Nie znaleźliśmy wyników odpowiadających Twojemu zapytaniu.',
			'no_results_title_headings': 'Aktualnie w bazie danych PBL nie odnotowaliśmy materiałów pasujących do wybranej grupy.',
			'no_results_desc': '<li>Sprawdź pisownię szukanej frazy. </li><li>Użyj hasła o podobnym znaczeniu lub wprowadź bardziej ogólne zapytanie. </li><li>Spróbuj ograniczyć liczbę słów w szukanej frazie.</li>',
			'no_results_suggestions': 'Sugestie',
			'no_results_other_desc': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
			'contact': 'mailto:pracownia@pbl.ibl.poznan.pl',
		},
		filter_labels: {
			'HEADING': 'Dziedzina i dział PBL',
			'HEADINGS': 'Dziedzina i dział PBL',
			'ORIGIN_SOURCE': 'Proweniencja informacji',
			'CROSS_HEADING': 'Działy przekrojowe',
			'FORM': 'Forma',
			'RECORD_FORM': 'Forma',
			'SERIES_FORM': 'Forma',
			'RECORD_TYPE': 'Rodzaj zapisu',
			'FILE_TYPE': 'Typ kartoteki',
			'EVENT_TYPE': 'Rodzaj wydarzenia',
			'INSTITUTION_TYPE': 'Rodzaj instytucji',
			'SERIES_TYPE': 'Rodzaj cyklu',
			'SERIES_PERSONS_FUNCTION': 'Osoba i jej funkcja',
			'YEAR': 'Rok',
			'JOURNAL_YEAR': 'Rocznik',
			'LANGUAGE': 'Język publikacji',
			'PERSON': 'Osoba i jej funkcje',
			'RECORD_PERSON': 'Osoba i jej funkcje',
			'SERIES_PERSON': 'Osoba i jej funkcje',
			'PERSONS_FUNCTION': 'Funkcja osoby',
			'RECORD_PERSONS_FUNCTION': 'Funkcja osoby',
			'SERIES_RECORDS_FUNCTION': 'Funkcja osoby',
			'RECORD_LOCATION': 'Miejsce',
			'BORN_LOCATION': 'Miejsce urodzenia',
			'DEATH_LOCATION': 'Miejsce śmierci',
			'JOURNAL_LOCATION': 'Miejsce wydawania',
			'EVENT_LOCATION': 'Miejsce wydarzenia',
			'INSTITUTION_LOCATION': 'Miejsce działalności',
			'SOURCE': 'Źródło',
			'RECORD_SOURCE': 'Źródło',
			'SERIES_SOURCE': 'Źródło',
			'COLLECTION': 'Kolekcja',
			'BORN_YEAR': 'Rok urodzenia',
			'DEATH_YEAR': 'Rok śmierci',
			'SEX': 'Płeć',
			'AUTHOR': 'Autor/ka',
			'JOURNAL_CHARACTER': 'Charakter czasopisma',
			'FREQUENCY': 'Częstotliwość wydawania',
			'EVENT_DATE': 'Data wydarzenia',
			'EVENT_PERIOD': 'Za okres',
			'SERIES': 'Przynależność do cyklu',
			'ORGANIZER': 'Organizator',
			'LAUREATE': 'Laureat/ka',
			'INSTITUTION_PERIOD': 'Okres działalności',
			'NUMBER': 'Numer',
		},
		date_range: {
			'required': 'Data nie może być pusta.',
			'required_bc': 'Data p.n.e. nie może być pusta.',
			'format': 'Zły format daty.',
			'out_of_range': 'Data jest późniejsza niż data dzisiejsza.',
			'to_exceeds_from': 'Data od jest późniejsza niż data do.',
		},
		pagination: {
			'from': 'z',
			'previous': 'Poprzednia',
			'previous_title': 'Poprzednia strona',
			'next': 'Następna',
			'next_title': 'Następna strona',
			'input': 'Wpisz numer strony',
		},
		ipp: {
			'results_number': 'wyników na stronie'
		},
		sort: {
			'accuracy': 'Sortuj według trafności',
			'author_asc': 'Sortuj według autora rosnąco (alfabetycznie)',
			'author_desc': 'Sortuj według autora malejąco (alfabetycznie)',
			'name_asc': 'Sortuj według nazwy rosnąco (alfabetycznie)',
			'name_desc': 'Sortuj według nazwy malejąco (alfabetycznie)',
			'title_asc': 'Sortuj według tytułu rosnąco (alfabetycznie)',
			'title_desc': 'Sortuj według tytułu malejąco (alfabetycznie)',
			'date_asc': 'Sortuj według daty rosnąco',
			'date_desc': 'Sortuj według daty malejąco',
			'source_title_asc': 'Sortuj według źródła alfabetycznie',
		},
		login_page: {
			'title': 'Logowanie',
			'username': 'Nazwa użytkownika',
			'password': 'Hasło',
			'login': 'Zaloguj',
			'username_required': 'Nazwa użytkownika jest wymagana',
			'password_required': 'Hasło jest wymagane',
		},
		alt: {
			'chevron_up': 'Strzałka w górę',
			'chevron_down': 'Strzałka w dół',
			'chevron_right': 'Strzałka w prawo',
			'chevron_left': 'Strzałka w lewo',
			'double_chevron_left': 'Podwójna strzałka w lewo',
			'arrow_circle_full': 'Strzałka w prawo w pełnym okręgu',
			'arrow_circle_empty': 'Strzałka w prawo w pustym okręgu',
			'plus': 'Ikona plusa',
			'bin': 'Ikona śmietnika',
			'warning': 'Ikona ostrzeżenia',
			'mail': 'Ikona koperty',
			'structure': 'Ikona struktury',
			'search': 'Ikona lupki',
			'folder': 'Obrazek odnoszący się do folderu',
			'collection': 'Obrazek odnoszący się do kolekcji',
			'cookies': 'Ikona ciasteczka',
			'partners': 'Logo partnera',
			'menu': 'Ikona menu',
			'home': 'Ikona domku',
			'card': 'Ikona karty',
			'csv': 'Ikona CSV',
			'api': 'Ikona API',
			'book': 'Ikona książki',
			'content': 'Ikona zawartości',
			'journal': 'Ikona gazety',
			'journal_number': 'Ikona numeru gazety',
			'journal_item': 'Ikona materiałów w gazecie',
			'event_series': 'Ikona zawartości',
			'institution': 'Ikona instytucji',
			'person': 'Ikona osoby',
			'series': 'Ikona serii',
			'spectacle': 'Ikona spektaklu',
			'movie': 'Ikona filmu',
			'creative_work': 'Ikona utworu',
			'event': 'Ikona wydarzenia',
			'tv': 'Ikona telewizji',
			'radio': 'Ikona radia',
			'link': 'Ikona linku zewnętrznego',
			'author_company': 'Ikona zawartości',
			'record': 'Ikona zapisu',
			'record_type': 'Ikona typu zapisu',
			'video_dots': 'Obrazek kropek',
			'video_poster': 'Plakat przedstawiający Krzystofa Kamila Baczyńskiego na tle miasta z napisem Polska Bibliografia Literacka Kolekcja Tekstów',
			'info': 'Ikona informacji',
			'no_results': 'Obrazek z rozsypanymi spinaczami',
			'results_icon': 'Ikona z typem zapisu',
			'logo': 'Logo PBL',
			'loader': 'Login loader icon',
			'externalLinks': 'Link zewnętrzny'
		},
		dropdown: {
			'download_format_label': 'Pobierz opis bibliograficzny',
			"download_format_item": "Pobierz",
		},
		title: {
			'csv': 'Pobierz plik CSV',
			'api': 'Przejdź do API',
			'home': 'Przejdź do strony głównej',
			'up': 'Wróć na górę strony',
			'contact': 'Kontakt z redaktorem działu',
			'error': 'Zgłoś błąd do redaktora',
			'facebook': 'Odwiedź i polub profil PBL na Facebooku - otwórz w nowym oknie',
			'possibilities_btn': 'PBL w repozytorium OPEN - otwórz stronę w nowym oknie',
			'carousel_prev': 'Pokaż poprzednie elementy paska',
			'carousel_next': 'Pokaż kolejne elementy paska',
			'queries_examples': 'Przejdź do strony z przykładem',
			'pl_title': 'Polska wersja językowa',
			'en_title': 'English language version',
			'search_bar': 'Wyszukiwarka',
			"pagination_btn": "Przycisk paginacji"
		},
		aria: {
			'search_bar': "Szukana fraza",
		},
		loading_gif: 'Strona ładuje się',
		loading_text: 'Strona w trakcie ładowania. Może to potrwać kilka sekund.',
		loading_error: 'Wystąpił błąd, przepraszamy.',
		show_more: 'Zobacz więcej',
		show_all: 'Pokaż wszystkie',
		back: 'Powrót',
		close: 'Zamknij',
		submit: 'Zastosuj',
		cancel: 'Anuluj',
		select_all: 'Zaznacz wszystko',
		clean_all: 'Wyczyść zaznaczenie',
		clean: 'Wyczyść',
		search_for: 'Szukaj',
		look_for: 'Wyszukaj',
		pl: 'Polski',
		en: 'English',
		font: 'Rozmiar czcionki',
		font_default: 'Czcionka domyślna',
		font_medium: 'Czcionka średnia',
		font_big: 'Czcionka duża',
		font_default_text: 'Włączona czcionka domyślna',
		font_medium_text: 'Włączona czcionka średnia',
		font_big_text: 'Włączona czcionka duża',
		contrast: 'Kontrast',
		contrast_default: 'Kontrast domyślny',
		contrast_black_yellow: 'Kontrast czarno-żółty',
		contrast_default_text: 'Włączony kontrast domyślny',
		contrast_black_yellow_text: 'Włączony kontrast czarno-żółty',
		home: 'Strona główna',
		login: 'Zaloguj się',
		login_hello: 'Witaj ',
		logout: 'Wyloguj się',
		read_more: 'Czytaj więcej',
		cookies_desc: 'Używamy plików cookies, by ułatwić korzystanie z naszego serwisu. Jeżeli nie chcesz, by pliki cookies były zapisywane na Twoim dysku, zmień ustawienia swojej przeglądarki. Sprawdź informacje o plikach cookies i polityce prywatności.',
		welcome_desc: 'Witamy na stronie „Polskiej Bibliografii Literackiej”, powstałej w ramach grantu Narodowego Programu Rozwoju Humanistyki (nr 0061/NPRH3/H11/82/2014). Serwis jest wciąż rozwijany - zachęcamy do jego testowania i zgłaszania uwag. W okresie przejściowym pełen zasób danych bibliograficznych dostępny jest pod adresem <a href="www.pbl.ibl.poznan.pl">www.pbl.ibl.poznan.pl</a>.',
		welcome_go: 'Przejdź do portalu',
		cookies_header: 'Używamy plików cookies.',
		accept: 'Rozumiem',
	}
};



// WEBPACK FOOTER //
// ./src/constants/Languages.js